<div tabindex="0" class="flex items-center justify-center w-full h-full icon-container" [ngSwitch]="code">
  @switch (code | lowercase) {
    <!-- Angola -->
    @case ('ao') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v256l-253 36.6L0 256z"/>
          <path fill="#333" d="M0 256h512v256H0z"/>
          <g fill="#ffda44">
            <path d="m220.9 203.6 21.7 15.8-8.3 25.5L256 229l21.7 15.7-8.3-25.5 21.7-15.7h-26.8L256 178l-8.3 25.5z"/>
            <path d="M320 145.1a127.2 127.2 0 0 0-64-17v33.3a94 94 0 0 1 47.3 12.7 94.7 94.7 0 0 1-94.6 163.8 94 94 0 0 1-31.6-29.8l-27.9 18.4a128.1 128.1 0 0 0 217.7-6.5A128.1 128.1 0 0 0 320 145.1z"/>
            <path d="M182.2 233.7a33.4 33.4 0 0 0 13.3 45.4l108.4 59.2c-7.4 13.5-3.4 30 10 37.3l29.3 16a27.8 27.8 0 0 0 37.8-11l16-29.3z"/>
          </g>
        </g>
      </svg>
    }

    <!-- Anguilla -->
    @case ('ai') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
          <path fill="#496e2d" d="M445.2 256.1zm-155.8 0z"/>
          <path fill="#eee" d="M433 293.6a62.4 62.4 0 0 0 12.2-37.5V144.8a55.4 55.4 0 0 1-33.4 11.1 55.6 55.6 0 0 1-44.5-22.2 55.6 55.6 0 0 1-44.5 22.2 55.4 55.4 0 0 1-33.4-11.1v111.3c0 15 5 27.3 12.3 37.5h131.2z"/>
          <path fill="#ff9811" d="M409.8 235.5a91 91 0 0 0 6.3-27.6c0-10.1-13.2-18.3-13.2-18.3s-13.2 8.2-13.2 18.3a91 91 0 0 0 6.3 27.6l-7.6 17.1a38.3 38.3 0 0 0 29 0zm-51.5-55.6a91 91 0 0 0-27 8.3c-8.8 5-9.3 20.5-9.3 20.5s13.7 7.4 22.4 2.3c5.5-3.1 15-11.8 20.8-19.2l18.6-2a38.4 38.4 0 0 0-4.7-14 38.4 38.4 0 0 0-9.7-11.1zm-22.4 72.2a91 91 0 0 0 20.7 19.3c8.8 5 22.5-2.3 22.5-2.3s-.6-15.5-9.3-20.5a91 91 0 0 0-27-8.4l-11.1-15.1a38.4 38.4 0 0 0-9.7 11 38.4 38.4 0 0 0-4.8 14z"/>
          <path fill="#338af3" d="M299 289.5c20.7 33.3 68.3 44.5 68.3 44.5s47.6-11.2 68.4-44.5H298.9Z"/>
        </g>
      </svg>
    }

    <!-- Antarctica -->
    @case ('aq') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <path fill="#eee" d="m135 343-41-70 17-38-40-51-9-37 74 51 45-11 19-67 50-29 75 11 87 45 4 74 28 10v76l-53 94-64 20-59-14 15-25-7-26-8 7z"/>
        </g>
      </svg>
    }

    <!-- Argentina -->
    @case ('ar') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v144.7L488 256l24 111.3V512H0V367.3L26 256 0 144.7z"/>
          <path fill="#eee" d="M0 144.7h512v222.6H0z"/>
          <path fill="#ffda44" d="m332.4 256-31.2 14.7 16.7 30.3-34-6.5-4.2 34.3-23.7-25.2-23.6 25.2-4.3-34.3-34 6.5 16.6-30.3-31.2-14.7 31.3-14.7L194 211l34 6.5 4.3-34.3 23.6 25.2 23.6-25.2 4.4 34.3 34-6.5-16.7 30.3z"/>
        </g>
      </svg>
    }

    <!-- Armenia -->
    @case ('am') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="m0 166.9 253-26.7L512 167v178l-261.1 26L0 344.8z"/>
          <path fill="#d80027" d="M0 0h512v166.9H0z"/>
          <path fill="#ff9811" d="M0 344.9h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Aruba -->
    @case ('aw') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask><g mask="url(#a)">
          <path fill="#ffda44" d="m0 322.8 253.6-18.4L512 322.8v33.4l-258 15.3L0 356.2zm0 66.8 257.2-13.8L512 389.6V423l-253 16.9L0 423z"/>
          <path fill="#338af3" d="M0 0h512v322.8H0zm0 356.2h512v33.4H0zM0 423h512v89H0z"/>
          <path fill="#eee" d="m117.3 161.5-50-22.1 50-22 22-50.1 22.2 50 50 22-50 22.2-22.1 50z"/>
          <path fill="#d80027" d="m139.4 94.9 13.6 30.9 31 13.6-31 13.6-13.6 31-13.6-31-31-13.6 31-13.6z"/>
        </g>
      </svg>
    }

    <!-- Australia -->
    @case ('au') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask><g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#eee" d="m154 300 14 30 32-8-14 30 25 20-32 7 1 33-26-21-26 21 1-33-33-7 26-20-14-30 32 8zm222-27h47l-38 27 15-44 14 44zm7-162 7 15 16-4-7 15 12 10-15 3v17l-13-11-13 11v-17l-15-3 12-10-7-15 16 4zm57 67 7 15 16-4-7 15 12 10-15 3v16l-13-10-13 11v-17l-15-3 12-10-7-15 16 4zm-122 22 7 15 16-4-7 15 12 10-15 3v16l-13-10-13 11v-17l-15-3 12-10-7-15 16 4zm65 156 7 15 16-4-7 15 12 10-15 3v17l-13-11-13 11v-17l-15-3 12-10-7-15 16 4zM0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
        </g>
      </svg>
    }

    <!-- Austria -->
    @case ('at') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v167l-23.2 89.7L512 345v167H0V345l29.4-89L0 167z"/>
          <path fill="#eee" d="M0 167h512v178H0z"/>
        </g>
      </svg>
    }

    <!-- Azerbaijan -->
    @case ('az') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask><g mask="url(#a)">
          <path fill="#d80027" d="m0 166.9 253-31.8 259 31.8v178l-257.5 37.4L0 345z"/>
          <path fill="#338af3" d="M0 0h512v166.9H0z"/>
          <path fill="#6da544" d="M0 344.9h512V512H0z"/>
          <g fill="#eee">
            <path d="M261.6 328.2a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"/>
            <path d="m317.2 206 9.6 26.8 25.8-12.3-12.2 25.8 26.9 9.6-27 9.6 12.3 25.8-25.8-12.3-9.6 27-9.6-27-25.8 12.3 12.3-25.8-27-9.6 27-9.6-12.3-25.8 25.8 12.3z"/>
          </g>
        </g>
      </svg>
    }

    <!-- Bahamas -->
    @case ('bs') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v167l-37.4 89 37.4 89v167H0l49.6-252z"/>
          <path fill="#ffda44" d="M108.3 167H512v178H108.3z"/>
          <path fill="#333" d="M0 0v512l256-256L0 0z"/>
        </g>
      </svg>
    }

    <!-- Bahrain -->
    @case ('bh') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h182.5l88.1 268.5-88 243.5H0z"/>
          <path fill="#d80027" d="m182.5 0-82.3 42.7 82.3 42.7-82.3 42.6 82.3 42.7-82.3 42.7 82.3 42.6-82.3 42.7 82.3 42.7-82.3 42.6 82.3 42.7-82.3 42.7 82.3 42.6H512V0H182.5z"/>
        </g>
      </svg>
    }

    <!-- Bangladesh -->
    @case ('bd') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h512v512H0z"/>
          <circle cx="200.3" cy="256" r="111.3" fill="#d80027"/>
        </g>
      </svg>
    }

    <!-- Barbados -->
    @case ('bb') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h144.8l112.9 36.7L367.4 0H512v512H367.4l-108.9-38.1L144.8 512H0z"/>
          <path fill="#ffda44" d="M144.8 0h222.6v512H144.8z"/>
          <path fill="#333" d="m334.1 155.8 14.8 7.5-14.9-7.5-15-7.4c-.8 1.8-20.3 41.4-23.5 102h-22.7v-94.6l-16.7-22.2-16.7 22.2v94.6h-22.7a278.3 278.3 0 0 0-23.6-102l-29.8 14.9c.2.4 20.5 41.7 20.5 103.8v16.7h55.6v94.6h33.4v-94.6h55.6v-16.7c0-32 5.6-58.6 10.3-75.1 5-18 10.2-28.6 10.3-28.7l-15-7.5z"/>
        </g>
      </svg>
    }

    <!-- Belarus -->
    @case ('by') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h155.8l35 254.6-35 257.4H0z"/>
          <path fill="#a2001d" d="M155.8 0H512v345.1l-183 37.4-173.2-37.4z"/>
          <path fill="#6da544" d="M155.8 345.1H512V512H155.8z"/>
          <path fill="#a2001d" d="M50 .2 22.3 50l27.8 50.4L77.9 50zm55.8 0L78 50l27.7 50.4 28-50.4zM50 137.5l-27.7 49.6 27.8 50.5 27.7-50.5zm55.8 0L78 187.1l27.7 50.5 28-50.5zM50 274.7l-27.7 49.7 27.8 50.4 27.8-50.4zm55.8 0L78 324.4l27.7 50.4 28-50.4zM50 412l-27.7 49.6 27.8 50.5 27.7-50.5zm55.8 0L78 461.6l27.7 50.5 28-50.5z"/>
        </g>
      </svg>
    }

    <!-- Belgium -->
    @case ('be') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#333" d="M0 0h167l38.2 252.6L167 512H0z"/>
          <path fill="#d80027" d="M345 0h167v512H345l-36.7-256z"/>
          <path fill="#ffda44" d="M167 0h178v512H167z"/>
        </g>
      </svg>
    }

    <!-- Benin -->
    @case ('bj') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask><g mask="url(#a)">
          <path fill="#6da544" d="M0 0h189.2l54 257.6-54 254.4H0z"/>
          <path fill="#ffda44" d="M189.2 0H512v256l-159 53.5L189.1 256z"/>
          <path fill="#d80027" d="M189.2 256H512v256H189.2z"/>
        </g>
      </svg>
    }

    <!-- Bolivia -->
    @case ('bo') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask><g mask="url(#a)">
          <path fill="#ffda44" d="m0 167 252.9-29.3L512 167v178l-255.7 25.7L0 345z"/>
          <path fill="#d80027" d="M0 0h512v167H0z"/>
          <path fill="#6da544" d="M0 345h512v167H0z"/>
        </g>
      </svg>
    }

    <!-- Botswana -->
    @case ('bw') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#75aadb" d="M0 0h512v512H0z"/>
          <path fill="#000" d="M0 200h512v112H0z"/>
          <path fill="#fff" d="M0 224h512v64H0z"/>
        </g>
      </svg>
    }

    <!-- Bouvet Island -->
    @case ('bv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M144 0h64v512h-64z"/>
          <path fill="#fff" d="M0 224h512v64H0z"/>
          <path fill="#002664" d="M160 0h32v512h-32z"/>
          <path fill="#002664" d="M0 240h512v32H0z"/>
        </g>
      </svg>
    }

    <!-- Brazil -->
    @case ('br') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M256 100 476 256 256 412 36 256z"/>
          <circle cx="256" cy="256" r="96" fill="#f0f0f0"/>
          <path fill="#002776" d="M352 288a96 96 0 0 1-174-52c71 0 129 18 174 52z"/>
        </g>
      </svg>
    }

    <!-- British Indian Ocean Territory -->
    @case ('io') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M0 64h512v64H0zM0 192h512v64H0zM0 320h512v64H0zM0 448h512v64H0z"/>
          <path fill="#0052b4" d="M0 0l256 256L0 512V0z"/>
          <path fill="#f0f0f0" d="M112 0h32v512h-32zM0 240h512v32H0z"/>
          <path fill="#ffda44" d="M384 256l40-40 40 40-40 40z"/>
          <path fill="#6da544" d="M384 320l40-40 40 40-40 40z"/>
        </g>
      </svg>
    }

    <!-- Brunei Darussalam -->
    @case ('bn') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v512H0z"/>
          <path fill="#000" d="M-41 512 512 49v78L41 512z"/>
          <path fill="#f0f0f0" d="M-21 512 512 72v56L19 512z"/>
          <!-- emblem omitted for simplicity -->
        </g>
      </svg>
    }

    <!-- Bulgaria -->
    @case ('bg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v170.7H0z"/>
          <path fill="#6da544" d="M0 170.7h512v170.6H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Burkina Faso -->
    @case ('bf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v256H0z"/>
          <path fill="#6da544" d="M0 256h512v256H0z"/>
          <path fill="#ffda44" d="m256 178 17.6 54.2h57l-46.1 33.5 17.6 54.1L256 286.2l-46.1 33.6 17.6-54.1-46.1-33.5h57z"/>
        </g>
      </svg>
    }

    <!-- Burundi -->
    @case ('bi') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="m0 0 512 512z"/>
          <path fill="#f0f0f0" d="m512 0-512 512z"/>
          <path fill="#6da544" d="m0 0 256 256L0 512z"/>
          <path fill="#6da544" d="m512 0-256 256 256 256z"/>
          <circle cx="256" cy="256" r="89.5" fill="#f0f0f0"/>
          <g fill="#d80027">
            <path d="m256 195 9 27.7h29.2l-23.6 17.2 9 27.7-23.6-17.2-23.6 17.2 9-27.7-23.6-17.2H247z"/>
            <path d="m202 222.7 9 27.6H240l-23.6 17.3 9 27.6-23.6-17.2-23.6 17.2 9-27.6-23.6-17.3H193z"/>
            <path d="m310 222.7 9 27.6h29.2l-23.6 17.3 9 27.6-23.6-17.2-23.6 17.2 9-27.6-23.6-17.3H301z"/>
          </g>
        </g>
      </svg>
    }

    <!-- Cambodia -->
    @case ('kh') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M0 0h512v128H0zM0 384h512v128H0z"/>
          <g fill="#f0f0f0">
            <path d="M195 256h122v56H195z"/>
            <path d="M217 224h78v32h-78z"/>
            <path d="M239 192h34v32h-34z"/>
            <path d="M211 280h90v22h-90z"/>
          </g>
        </g>
      </svg>
    }

    <!-- Cameroon -->
    @case ('cm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h170.7v512H0z"/>
          <path fill="#d80027" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#6da544" d="M341.3 0H512v512H341.3z"/>
          <path fill="#ffda44" d="m256 178 17.6 54.2h57l-46.1 33.5 17.6 54.1L256 286.2l-46.1 33.6 17.6-54.1-46.1-33.5h57z"/>
        </g>
      </svg>
    }

    <!-- Canada -->
    @case ('ca') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h128v512H0zm384 0h128v512H384z"/>
          <path fill="#f0f0f0" d="M128 0h256v512H128z"/>
          <path fill="#d80027" d="m256 122-19.2 42.2-45.8-6.3 21.8 40.7-39.1 23.4 39.1 23.4-21.8 40.7 45.8-6.3L256 390l19.2-42.2 45.8 6.3-21.8-40.7 39.1-23.4-39.1-23.4 21.8-40.7-45.8 6.3z"/>
        </g>
      </svg>
    }

    <!-- Cape Verde -->
    @case ('cv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#003897" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M0 256h512v44H0zM0 300h512v44H0z"/>
          <path fill="#cf2e26" d="M0 278h512v22H0z"/>
          <g fill="#ffda44">
            <circle cx="120" cy="330" r="10"/>
            <circle cx="150" cy="350" r="10"/>
            <circle cx="180" cy="340" r="10"/>
            <circle cx="200" cy="310" r="10"/>
            <circle cx="200" cy="275" r="10"/>
            <circle cx="180" cy="250" r="10"/>
            <circle cx="150" cy="240" r="10"/>
            <circle cx="120" cy="260" r="10"/>
            <circle cx="110" cy="295" r="10"/>
            <circle cx="135" cy="315" r="10"/>
          </g>
        </g>
      </svg>
    }

    <!-- Central African Republic -->
    @case ('cf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v102.4H0z"/>
          <path fill="#fff" d="M0 102.4h512v102.4H0z"/>
          <path fill="#d80027" d="M0 204.8h512v102.4H0z"/>
          <path fill="#6da544" d="M0 307.2h512v102.4H0z"/>
          <path fill="#ffda44" d="M0 409.6h512V512H0z"/>
          <path fill="#d80027" d="M204.8 0h102.4v512H204.8z"/>
          <path fill="#ffda44" d="m51.2 51.2 12.6 38.8H105l-33.2 24.1 12.6 38.9-33.2-24.2-33.2 24.2 12.6-38.9L0 90h41.2z"/>
        </g>
      </svg>
    }

    <!-- Chad -->
    @case ('td') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h170.7v512H0z"/>
          <path fill="#ffda44" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Chile -->
    @case ('cl') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v256H0z"/>
          <path fill="#0052b4" d="M0 0h256v256H0z"/>
          <path fill="#fff" d="m128 89 14.8 45.5H192l-38.4 27.9 14.7 45.5-38.3-27.9-38.4 27.9 14.8-45.5-38.4-27.9h47.2z"/>
        </g>
      </svg>
    }

    <!-- China -->
    @case ('cn') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="m144 144 24 73.7-62.5-45.4h77L120 217.7z"/>
          <path fill="#ffda44" d="m232 104 10 30-26.5-19.3H248l-26.5 19.3z"/>
          <path fill="#ffda44" d="m272 144 10 30-26.5-19.3H288l-26.5 19.3z"/>
          <path fill="#ffda44" d="m272 208 10 30-26.5-19.3H288l-26.5 19.3z"/>
          <path fill="#ffda44" d="m232 248 10 30-26.5-19.3H248l-26.5 19.3z"/>
        </g>
      </svg>
    }

    <!-- Colombia -->
    @case ('co') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v128H0z"/>
          <path fill="#0052b4" d="M0 384h512v128H0z"/>
        </g>
      </svg>
    }

    <!-- Comoros -->
    @case ('km') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v128H0z"/>
          <path fill="#fff" d="M0 128h512v128H0z"/>
          <path fill="#d80027" d="M0 256h512v128H0z"/>
          <path fill="#6da544" d="M0 384h512v128H0z"/>
          <path fill="#007847" d="M0 0v512l256-256z"/>
          <g fill="#fff">
            <circle cx="88" cy="160" r="10"/>
            <circle cx="88" cy="192" r="10"/>
            <circle cx="88" cy="224" r="10"/>
            <circle cx="88" cy="256" r="10"/>
            <circle cx="88" cy="288" r="10"/>
            <circle cx="88" cy="320" r="10"/>
            <circle cx="88" cy="352" r="10"/>
            <circle cx="88" cy="384" r="10"/>
          </g>
        </g>
      </svg>
    }

    <!-- Congo -->
    @case ('cg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M0 512 512 0v224L224 512z"/>
          <path fill="#6da544" d="M0 0v288L288 0z"/>
        </g>
      </svg>
    }

    <!-- Congo, The Democratic Republic of the -->
    @case ('cd') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#007fff" d="M0 0h512v512H0z"/>
          <path fill="#f7d618" d="m0 472 472-472h40v40L40 512H0z"/>
          <path fill="#ce1126" d="m0 432 432-432h80L0 512z"/>
          <path fill="#f7d618" d="m128 96 12.7 39H184l-32.6 23.7L164 198l-36-26-36 26 12.6-39.3L72 135h43.4z"/>
        </g>
      </svg>
    }

    <!-- Costa Rica -->
    @case ('cr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M0 0h512v102.4H0zM0 409.6h512V512H0z"/>
          <path fill="#d80027" d="M0 204.8h512v102.4H0z"/>
        </g>
      </svg>
    }

    <!-- Cote D'Ivoire -->
    @case ('ci') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ff9811" d="M0 0h170.7v512H0z"/>
          <path fill="#f0f0f0" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#6da544" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Cuba -->
    @case ('cu') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v102.4H0zM0 204.8h512v102.4H0zM0 409.6h512V512H0z"/>
          <path fill="#f0f0f0" d="M0 102.4h512v102.4H0zM0 307.2h512v102.4H0z"/>
          <path fill="#d80027" d="M0 0v512l256-256z"/>
          <path fill="#fff" d="m96 192 15.7 48.4H162l-42.3 30.7 15.8 48.4L96 288l-42.3 30.7 15.8-48.4L27.2 240h50.3z"/>
        </g>
      </svg>
    }

    <!-- Czech Republic -->
    @case ('cz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v256H0z"/>
          <path fill="#0052b4" d="M0 0v512l256-256z"/>
        </g>
      </svg>
    }

    <!-- Denmark -->
    @case ('dk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="M144 0h64v512h-64z"/>
          <path fill="#f0f0f0" d="M0 224h512v64H0z"/>
        </g>
      </svg>
    }

    <!-- Djibouti -->
    @case ('dj') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 256h512v256H0z"/>
          <path fill="#338af3" d="M0 0h512v256H0z"/>
          <path fill="#f0f0f0" d="M0 0v512l256-256z"/>
          <path fill="#d80027" d="m91.7 195.5 15.3 47.2H157l-40.6 29.5 15.3 47.2-40.7-29.6-40.6 29.6 15.3-47.2-40.6-29.5h50z"/>
        </g>
      </svg>
    }

    <!-- Ecuador -->
    @case ('ec') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v170.7H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
          <path fill="#0052b4" d="M0 170.7h512v170.6H0z"/>
          <!-- emblem omitted -->
        </g>
      </svg>
    }

    <!-- Egypt -->
    @case ('eg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
          <path fill="#ffda44" d="M256 234.7a21.3 21.3 0 1 0 0 42.6 21.3 21.3 0 0 0 0-42.6z"/>
        </g>
      </svg>
    }

    <!-- El Salvador -->
    @case ('sv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#0052b4" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Estonia -->
    @case ('ee') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Ethiopia -->
    @case ('et') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v170.7H0z"/>
          <path fill="#ffda44" d="M0 170.7h512v170.6H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
          <circle cx="256" cy="256" r="96" fill="#0052b4"/>
          <!-- Emblem simplified -->
          <path fill="#ffda44" d="m256 192 12 36h38l-30 22 12 36-30-22-30 22 12-36-30-22h38z"/>
        </g>
      </svg>
    }

    <!-- Faroe Islands -->
    @case ('fo') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M144 0h64v512h-64z"/>
          <path fill="#0052b4" d="M0 224h512v64H0z"/>
          <path fill="#d80027" d="M160 0h32v512h-32z"/>
          <path fill="#d80027" d="M0 240h512v32H0z"/>
        </g>
      </svg>
    }

    <!-- Finland -->
    @case ('fi') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M144 0h64v512h-64z"/>
          <path fill="#0052b4" d="M0 224h512v64H0z"/>
        </g>
      </svg>
    }

    <!-- France -->
    @case ('fr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h170.7v512H0z"/>
          <path fill="#f0f0f0" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- French Guiana -->
    @case ('gf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M0 0v512l512-512z"/>
          <path fill="#d80027" d="m256 160 19.2 59.2h62.4l-50.4 36.7 19.2 59.2-50.4-36.8-50.4 36.8 19.2-59.2-50.4-36.7h62.4z"/>
        </g>
      </svg>
    }

    <!-- French Polynesia -->
    @case ('pf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v128H0zM0 384h512v128H0z"/>
          <path fill="#f0f0f0" d="M0 128h512v256H0z"/>
          <circle cx="256" cy="256" r="64" fill="#ff9811"/>
        </g>
      </svg>
    }

    <!-- Gabon -->
    @case ('ga') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v170.7H0z"/>
          <path fill="#ffda44" d="M0 170.7h512v170.6H0z"/>
          <path fill="#0052b4" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Gambia -->
    @case ('gm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v28.5H0z"/>
          <path fill="#0052b4" d="M0 199.2h512v113.6H0z"/>
          <path fill="#f0f0f0" d="M0 312.8h512v28.5H0z"/>
          <path fill="#496e2d" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Georgia -->
    @case ('ge') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M216 0h80v216h216v80H296v216h-80V296H0v-80h216z"/>
          <g fill="#d80027">
            <path d="M128 128h32v96h-32zM96 160h96v32H96zM384 128h32v96h-32zM352 160h96v32H352zM128 384h32v96h-32zM96 416h96v32H96zM384 384h32v96h-32zM352 416h96v32H352z"/>
          </g>
        </g>
      </svg>
    }

    <!-- Germany -->
    @case ('de') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#000" d="M0 0h512v170.7H0z"/>
          <path fill="#d00" d="M0 170.7h512v170.6H0z"/>
          <path fill="#ffce00" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Ghana -->
    @case ('gh') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#ffda44" d="M0 170.7h512v170.6H0z"/>
          <path fill="#496e2d" d="M0 341.3h512V512H0z"/>
          <path fill="#000" d="m256 192 16.7 51.4h54.1l-43.7 31.8 16.7 51.4-43.8-31.8-43.7 31.8 16.7-51.4-43.7-31.8h54.1z"/>
        </g>
      </svg>
    }

    <!-- Greece -->
    @case ('gr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="M0 57.1h512v57.1H0zM0 171.3h512v57.1H0zM0 285.5h512v57.1H0zM0 399.7h512v57.1H0z"/>
          <path fill="#f0f0f0" d="M0 0h228.6v228.6H0z"/>
          <path fill="#0052b4" d="M91.4 0h45.7v228.6H91.4zM0 91.4h228.6v45.7H0z"/>
        </g>
      </svg>
    }

    <!-- Greenland -->
    @case ('gl') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v256H0z"/>
          <circle cx="176" cy="256" r="96" fill="#d80027"/>
          <path fill="#f0f0f0" d="M176 160a96 96 0 0 0 0 192z"/>
        </g>
      </svg>
    }

    <!-- Grenada -->
    @case ('gd') {
      <svg xmlns="http://www.w3.org/200/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ce1126" d="M0 0h512v512H0z"/>
          <path fill="#fcd116" d="M64 64h384v384H64z"/>
          <path fill="#007847" d="M64 64l384 384H64z"/>
          <circle cx="256" cy="256" r="48" fill="#ce1126"/>
          <path fill="#fcd116" d="m256 228 10.6 32.7h34.4l-27.8 20.2 10.6 32.7-27.8-20.2-27.8 20.2 10.6-32.7-27.8-20.2h34.4z"/>
        </g>
      </svg>
    }

    <!-- Guatemala -->
    @case ('gt') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h170.7v512H0zM341.3 0H512v512H341.3z"/>
          <path fill="#f0f0f0" d="M170.7 0h170.6v512H170.7z"/>
        </g>
      </svg>
    }

    <!-- Guernsey -->
    @case ('gg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M216 0h80v216h216v80H296v216h-80V296H0v-80h216z"/>
          <path fill="#ffda44" d="M240 0h32v240h240v32H272v240h-32V272H0v-32h240z"/>
        </g>
      </svg>
    }

    <!-- Guinea -->
    @case ('gn') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h170.7v512H0z"/>
          <path fill="#ffda44" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#6da544" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Guinea-Bissau -->
    @case ('gw') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M170.7 0H512v256H170.7z"/>
          <path fill="#6da544" d="M170.7 256H512v256H170.7z"/>
          <path fill="#d80027" d="M0 0h170.7v512H0z"/>
          <path fill="#000" d="m85.3 192 13.3 41h43.2l-35 25.4 13.3 41-35-25.4-35 25.4 13.3-41-35-25.4h43.2z"/>
        </g>
      </svg>
    }

    <!-- Guyana -->
    @case ('gy') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M0 0l512 256L0 512z"/>
          <path fill="#000" d="M0 0v512l256-256z"/>
          <path fill="#d80027" d="M40 256 256 416 40 256 256 96z"/>
        </g>
      </svg>
    }

    <!-- Haiti -->
    @case ('ht') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v256H0z"/>
          <rect x="192" y="192" width="128" height="128" fill="#f0f0f0"/>
        </g>
      </svg>
    }

    <!-- Holy See (Vatican City State) -->
    @case ('va') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h256v512H0z"/>
          <path fill="#f0f0f0" d="M256 0h256v512H256z"/>
        </g>
      </svg>
    }

    <!-- Honduras -->
    @case ('hn') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#338af3" d="M0 341.3h512V512H0z"/>
          <g fill="#338af3">
            <circle cx="256" cy="256" r="12"/>
            <circle cx="220" cy="220" r="12"/>
            <circle cx="292" cy="220" r="12"/>
            <circle cx="220" cy="292" r="12"/>
            <circle cx="292" cy="292" r="12"/>
          </g>
        </g>
      </svg>
    }

    <!-- Hungary -->
    @case ('hu') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Iceland -->
    @case ('is') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M144 0h64v512h-64z"/>
          <path fill="#fff" d="M0 224h512v64H0z"/>
          <path fill="#d80027" d="M160 0h32v512h-32z"/>
          <path fill="#d80027" d="M0 240h512v32H0z"/>
        </g>
      </svg>
    }

    <!-- India -->
    @case ('in') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ff9933" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#138808" d="M0 341.3h512V512H0z"/>
          <circle cx="256" cy="256" r="48" fill="none" stroke="#000080" stroke-width="6"/>
          <g fill="#000080">
            <circle cx="256" cy="208" r="4"/>
            <!-- 24 spokes omitted for simplicity -->
          </g>
        </g>
      </svg>
    }

    <!-- Indonesia -->
    @case ('id') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v256H0z"/>
          <path fill="#f0f0f0" d="M0 256h512v256H0z"/>
        </g>
      </svg>
    }

    <!-- Iraq -->
    @case ('iq') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
          <text x="256" y="290" font-size="64" fill="#007847" text-anchor="middle" font-family="sans-serif">الله أكبر</text>
        </g>
      </svg>
    }

    <!-- Ireland -->
    @case ('ie') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#169b62" d="M0 0h170.7v512H0z"/>
          <path fill="#fff" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#ff883e" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Italy -->
    @case ('it') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h170.7v512H0z"/>
          <path fill="#f0f0f0" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Japan -->
    @case ('jp') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#fff" d="M0 0h512v512H0z"/>
          <circle cx="256" cy="256" r="96" fill="#d80027"/>
        </g>
      </svg>
    }

    <!-- Jersey -->
    @case ('je') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M0 0l512 512M512 0L0 512" stroke="#d80027" stroke-width="60"/>
          <path fill="#ffda44" d="M256 80l28-20h-56z"/>
          <path fill="#d80027" d="M228 80h56v28h-56z"/>
        </g>
      </svg>
    }

    <!-- Jordan -->
    @case ('jo') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#000" d="M0 0h512v170.7H0z"/>
          <path fill="#fff" d="M0 170.7h512v170.6H0z"/>
          <path fill="#007a3d" d="M0 341.3h512V512H0z"/>
          <path fill="#d80027" d="M0 0v512l256-256z"/>
          <path fill="#fff" d="m85.3 256 10.7 33h34.7l-28.1 20.4 10.7 33-28.1-20.4-28.2 20.4 10.8-33-28.2-20.4h34.7z"/>
        </g>
      </svg>
    }

    <!-- Kenya -->
    @case ('ke') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#000" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v28.5H0zM0 312.8h512v28.5H0z"/>
          <path fill="#d80027" d="M0 199.2h512v113.6H0z"/>
          <path fill="#496e2d" d="M0 341.3h512V512H0z"/>
          <!-- simplified shield -->
          <ellipse cx="256" cy="256" rx="32" ry="96" fill="#000"/>
          <ellipse cx="256" cy="256" rx="24" ry="72" fill="#d80027"/>
        </g>
      </svg>
    }

    <!-- Israel -->
    @case ('il') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h512v55.7l-25 32.7 25 34v267.2l-26 36 26 30.7V512H0v-55.7l24.8-34.1L0 389.6V122.4l27.2-33.2L0 55.7z"/>
          <path fill="#0052b4" d="M0 55.7v66.7h512V55.7zm0 333.9v66.7h512v-66.7zm352.4-189.3H288l-32-55.6-32.1 55.6h-64.3l32.1 55.7-32 55.7h64.2l32.1 55.6 32.1-55.6h64.3L320.3 256l32-55.7zm-57 55.7-19.7 34.2h-39.4L216.5 256l19.8-34.2h39.4l19.8 34.2zM256 187.6l7.3 12.7h-14.6zm-59.2 34.2h14.7l-7.4 12.7zm0 68.4 7.3-12.7 7.4 12.7zm59.2 34.2-7.3-12.7h14.6zm59.2-34.2h-14.7l7.4-12.7zm-14.7-68.4h14.7l-7.3 12.7z"/>
        </g>
      </svg>
    }

    <!-- Kiribati -->
    @case ('ki') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v256H0z"/>
          <path fill="#0052b4" d="M0 256h512v256H0z"/>
          <path fill="#fff" d="M0 288c32 0 32 32 64 32s32-32 64-32 32 32 64 32 32-32 64-32 32 32 64 32 32-32 64-32 32 32 64 32 32-32 64-32v64c-32 0-32 32-64 32s-32-32-64-32-32 32-64 32-32-32-64-32-32 32-64 32-32-32-64-32-32 32-64 32S32 352 0 352z"/>
          <path fill="#ffda44" d="M256 128a64 64 0 0 0 64-64c-16 8-32 16-64 0-32 16-48 8-64 0a64 64 0 0 0 64 64z"/>
        </g>
      </svg>
    }

    <!-- Korea, Democratic People's Republic of Korea -->
    @case ('kp') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M0 96h512v64H0zM0 352h512v64H0z"/>
          <path fill="#d80027" d="M0 160h512v192H0z"/>
          <path fill="#fff" d="m160 256 21.2 65.3-55.2-40.1-55.2 40.1L92 256 70.8 190.7l55.2 40.1 55.2-40.1z"/>
        </g>
      </svg>
    }

    <!-- Kuwait -->
    @case ('kw') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v170.7H0z"/>
          <path fill="#6da544" d="M0 341.3h512V512H0z"/>
          <path fill="#d80027" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 0v512l170.7-170.7V170.7z"/>
        </g>
      </svg>
    }

    <!-- Kyrgyzstan -->
    @case ('kg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <circle cx="256" cy="256" r="96" fill="#ffda44"/>
          <path fill="#d80027" d="M256 192a64 64 0 1 1 0 128 64 64 0 0 1 0-128z"/>
          <!-- simplified sun rays omitted -->
        </g>
      </svg>
    }

    <!-- Lao People's Democratic Republic -->
    @case ('la') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M0 170.7h512v170.6H0z"/>
          <circle cx="256" cy="256" r="64" fill="#f0f0f0"/>
        </g>
      </svg>
    }

    <!-- Latvia -->
    @case ('lv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#a2001d" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="M0 213.3h512v85.4H0z"/>
        </g>
      </svg>
    }

    <!-- Lebanon -->
    @case ('lb') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v128H0zM0 384h512v128H0z"/>
          <path fill="#fff" d="M0 128h512v256H0z"/>
          <path fill="#6da544" d="M256 160 224 256h64zM256 192l-32 64h64zM224 224h64v32h-64z"/>
        </g>
      </svg>
    }

    <!-- Lesotho -->
    @case ('ls') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v170.7H0z"/>
          <path fill="#fff" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 341.3h512V512H0z"/>
          <path fill="#000" d="M256 224c-18 0-32 14-32 32s14 32 32 32 32-14 32-32-14-32-32-32z"/>
        </g>
      </svg>
    }

    <!-- Liberia -->
    @case ('lr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M0 45.5h512v45.5H0zM0 136.4h512v45.4H0zM0 227.3h512v45.4H0zM0 318.2h512v45.5H0zM0 409.1h512v45.5H0z"/>
          <path fill="#00247d" d="M0 0h182v182H0z"/>
          <path fill="#fff" d="m91 60 10.5 32.3h34L108 122.6l10.5 32.4L91 137.1l-27.5 17.9L74 122.6 56.5 92.3h34z"/>
        </g>
      </svg>
    }

    <!-- Åland Islands -->
    @case ('ax') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M144 0h64v512h-64zM0 224h512v64H0z"/>
          <path fill="#d80027" d="M160 0h32v512h-32zM0 240h512v32H0z"/>
        </g>
      </svg>
    }

    <!-- Albania -->
    @case ('al') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#333" d="M400.7 190H308a33.3 33.3 0 0 0-24.2-56.4 33.3 33.3 0 0 0-27.8 14.9 33.4 33.4 0 1 0-52 41.5h-92.7a45.8 45.8 0 0 0 46 44.5h-1.5c0 24.6 20 44.6 44.5 44.6 0 8 2.1 15.4 5.8 21.8l-37 37 28.4 28.3 40.2-40.2a30.5 30.5 0 0 0 4.9 1.4l-24.3 54.8L256 423l37.7-40.8-24.3-54.8a30.4 30.4 0 0 0 4.9-1.4l40.2 40.2 28.3-28.3-37-37a44.2 44.2 0 0 0 5.9-21.8c24.5 0 44.5-20 44.5-44.6h-1.5c24.6 0 46-19.9 46-44.5z"/>
        </g>
      </svg>
    }

    <!-- Algeria -->
    @case ('dz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h256l45.3 251.8L256 512H0z"/>
          <path fill="#eee" d="M256 0h256v512H256z"/><g fill="#d80027">
            <path d="m311 206.9-21 29-34-11 21 28.8-21 29 34-11.1 21 29v-35.8l34-11.1-34-11z"/>
            <path d="M277.2 328.3a72.3 72.3 0 1 1 34.5-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.5 8.7z"/>
          </g>
        </g>
      </svg>
    }

    <!-- American Samoa -->
    @case ('as') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M512 20.4V490L23.8 255.8z"/>
          <path fill="#a2001d" d="M445.2 246.5h-30.5c8-9.6 7.5-23.7-1.5-32.7a24.2 24.2 0 0 0 0-34.2l-.5.5a25 25 0 0 0 .5-34.8l-137 137a23.9 23.9 0 0 0 34 0l2.6-2.5 65.6-6v28.3h22.3v-30.2l33.4-3z"/>
          <path fill="#ffda44" d="M278.3 311.7 256 300.5l22.3-11.1H423v22.3z"/>
          <path fill="#0052b4" d="M0 0v512h512L28.7 256.2 512 0z"/>
          <path fill="#d80027" d="M512 0 0 256l512 256v-22L43.8 256 512 20.4z"/>
        </g>
      </svg>
    }

    <!-- Andorra -->
    @case ('ad') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h170.7v512H0z"/>
          <path fill="#ffda44" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
          <!-- emblem omitted for simplicity -->
        </g>
      </svg>
    }

    <!-- Macedonia -->
    @case ('mk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h68.2l86 33.6L216.5 0h78.8l61.2 34.8L443.8 0H512v68.3l-31.4 88 31.4 60.2v78.8L477.4 356l34.6 87.8V512h-68.2l-77-37.3-71.3 37.3h-78.8l-61-39.7L68.2 512H0v-68l40.3-88.2L0 295.5v-78.8L40.3 157 0 68.2z"/>
          <path fill="#d80027" d="M295.5 512h148.3L256 256zm-79-512H68.2L256 256zm.2 512L256 256 68.2 512zM0 216.7 256 256 0 68.2zm0 227.2L256 256 0 295.5zM512 68.3 256 256l256-39.5zM443.8 0H295.3L256 256zM512 443.8V295.3L256 256z"/>
          <circle cx="256" cy="256" r="89" fill="#d80027"/>
          <circle cx="256" cy="256" r="66.8" fill="#ffda44"/>
        </g>
      </svg>
    }

    <!-- Madagascar -->
    @case ('mg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h170.7v512H0z"/>
          <path fill="#d80027" d="M170.7 0H512v256H170.7z"/>
          <path fill="#6da544" d="M170.7 256H512v256H170.7z"/>
        </g>
      </svg>
    }

    <!-- Malawi -->
    @case ('mw') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#000" d="M0 0h512v170.7H0z"/>
          <path fill="#d80027" d="M0 170.7h512v170.6H0z"/>
          <path fill="#496e2d" d="M0 341.3h512V512H0z"/>
          <circle cx="256" cy="0" r="64" fill="#d80027"/>
        </g>
      </svg>
    }

    <!-- Malaysia -->
    @case ('my') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="M0 36.6h512v36.6H0zM0 109.8h512v36.6H0zM0 183h512v36.6H0zM0 256.2h512v36.6H0zM0 329.4h512v36.6H0zM0 402.6h512v36.6H0zM0 475.8h512V512H0z"/>
          <path fill="#0052b4" d="M0 0h256v256H0z"/>
          <circle cx="112" cy="128" r="48" fill="#ffda44"/>
          <path fill="#ffda44" d="m150 128-48 14.5 14.5-48-14.5-48 48 14.5 48-14.5-14.5 48 14.5 48z"/>
        </g>
      </svg>
    }

    <!-- Maldives -->
    @case ('mv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <rect x="128" y="128" width="256" height="256" fill="#007847"/>
          <circle cx="256" cy="256" r="48" fill="#f0f0f0"/>
          <circle cx="268" cy="256" r="32" fill="#007847"/>
        </g>
      </svg>
    }

    <!-- Maldives -->
    @case ('mv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <rect x="128" y="128" width="256" height="256" fill="#007847"/>
          <circle cx="256" cy="256" r="48" fill="#f0f0f0"/>
          <circle cx="268" cy="256" r="32" fill="#007847"/>
        </g>
      </svg>
    }

    <!-- Mali -->
    @case ('ml') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h170.7v512H0z"/>
          <path fill="#ffda44" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Malta -->
    @case ('mt') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h256v512H0z"/>
          <path fill="#d80027" d="M256 0h256v512H256z"/>
          <path fill="#acabb1" d="M96 96h48v48H96z"/>
          <path fill="#f0f0f0" d="M112 112h16v16h-16z"/>
        </g>
      </svg>
    }

    <!-- Mauritius -->
    @case ('mu') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v128H0z"/>
          <path fill="#0052b4" d="M0 128h512v128H0z"/>
          <path fill="#ffda44" d="M0 256h512v128H0z"/>
          <path fill="#6da544" d="M0 384h512v128H0z"/>
        </g>
      </svg>
    }

    <!-- Mexico -->
    @case ('mx') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#006847" d="M0 0h170.7v512H0z"/>
          <path fill="#fff" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#ce1126" d="M341.3 0H512v512H341.3z"/>
          <circle cx="256" cy="256" r="40" fill="#ffda44"/>
        </g>
      </svg>
    }

    <!-- Moldova -->
    @case ('md') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h144.7l36 254.6-36 257.4H0z"/>
          <path fill="#d80027" d="M367.3 0H512v512H367.3l-29.7-257.3z"/>
          <path fill="#ffda44" d="M144.7 0h222.6v512H144.7z"/>
          <path fill="#ff9811" d="M345.1 201.4H284a27.8 27.8 0 1 0-55.6 0h-61.2a28.2 28.2 0 0 0 28.3 27.4h-1a27.4 27.4 0 0 0 27.5 27.4c0 13.4 9.6 24.5 22.3 27l-21.6 48.7a88.8 88.8 0 0 0 33.5 6.5 88.8 88.8 0 0 0 33.5-6.5L268.1 283a27.4 27.4 0 0 0 22.3-26.9 27.4 27.4 0 0 0 27.4-27.4h-.9a28.2 28.2 0 0 0 28.3-27.4z"/>
          <path fill="#0052b4" d="M256.1 239.3 220 256v33.4l36.2 22.3 36.2-22.3V256z"/>
          <path fill="#d80027" d="M220 222.6h72.3V256H220z"/>
        </g>
      </svg>
    }

    <!-- Monaco -->
    @case ('mc') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v256H0z"/>
          <path fill="#f0f0f0" d="M0 256h512v256H0z"/>
        </g>
      </svg>
    }

    <!-- Mongolia -->
    @case ('mn') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#a2001d" d="M0 0h170.7v512H0zM341.3 0H512v512H341.3z"/>
          <path fill="#0052b4" d="M170.7 0h170.6v512H170.7z"/>
          <circle cx="85" cy="160" r="24" fill="#ffda44"/>
        </g>
      </svg>
    }

    <!-- Montserrat -->
    @case ('ms') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
          <path fill="#338af3" d="M289.4 133.6V256l78 40.4 77.9-40.4V133.6h-156z"/>
          <path fill="#a2001d" d="M289.4 256c0 59.6 77.9 78 77.9 78s78-18.4 78-78h-156z"/>
          <path fill="#333" d="M400.7 189.2h-22.3V167h-22.2v22.2h-22.3v22.3h22.3v66.8h22.2v-66.8h22.3z"/>
        </g>
      </svg>
    }

    <!-- Morocco -->
    @case ('ma') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#496e2d" d="M407.3 210H291.7L256 100.3 220.3 210H104.7l93.5 68-35.7 109.8L256 320l93.5 68-35.7-110zm-183 59.5 12.2-37.1h39l12.1 37.1-31.6 23-31.6-23zm44-59.4h-24.6l12.3-37.9zm38.3 45.7-7.7-23.4h39.9zM213 232.4l-7.7 23.4-32.2-23.4zm-8.3 97.3 12.3-38 20 14.5zm70.1-23.4 20-14.5 12.3 37.9z"/>
        </g>
      </svg>
    }

    <!-- Mozambique -->
    @case ('mz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h512v170.7H0z"/>
          <path fill="#ffda44" d="M0 170.7h512v170.6H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
          <path fill="#000" d="M0 0v512l256-256z"/>
          <path fill="#ffda44" d="m96 192 13.3 40.7h42.7l-34.6 25.1 13.2 40.7-34.6-25.1-34.7 25.1 13.3-40.7-34.6-25.1h42.6z"/>
        </g>
      </svg>
    }

    <!-- Myanmar -->
    @case ('mm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v170.7H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
          <path fill="#007a3d" d="M0 170.7h512v170.6H0z"/>
          <path fill="#fff" d="m256 144 34.2 105.2H400l-89.1 64.7L345.1 416 256 351.3 166.9 416l34.2-102.1L112 249.2h109.8z"/>
        </g>
      </svg>
    }

    <!-- Namibia -->
    @case ('na') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m0 401.9 160.6-237.1L401.9 0H449l63 63v47.3L350.3 339.2 110.3 512H63L0 449z"/>
          <path fill="#a2001d" d="M0 512h63L512 63V0h-63L0 449z"/>
          <path fill="#0052b4" d="M0 0v401.9L401.9 0z"/>
          <path fill="#496e2d" d="M512 512V110.3L110.3 512z"/>
          <path fill="#ffda44" d="m211.5 144.7-28.7 13.5L198 186l-31.2-6-4 31.5-21.6-23.2-21.7 23.2-4-31.5-31 6 15.2-27.8L71 144.7l28.7-13.5-15.3-27.8 31.1 6 4-31.5 21.7 23.2L163 78l4 31.5 31-6-15.2 27.8z"/>
        </g>
      </svg>
    }

    <!-- Nauru -->
    @case ('nr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v233.7L494.3 257l17.7 21.3V512H0V278.3l18.7-22.9L0 233.7z"/>
          <path fill="#eee" d="m211.5 345-28.7 13.5 15.3 27.8-31.2-6-4 31.5-21.6-23.1-21.7 23.1-4-31.4-31.1 6 15.3-27.9L71 345l28.7-13.4-15.3-27.8 31.1 6 4-31.5 21.7 23.1 21.7-23.1 4 31.4 31-6-15.2 27.9z"/>
          <path fill="#ffda44" d="M0 233.7h512v44.6H0z"/>
        </g>
      </svg>
    }

    <!-- Nepal -->
    @case ('np') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M228.4 0H512v512h-27.4L159.4 258.5z"/>
          <path fill="#0052b4" d="M510.5 283.8 228.5 0h-39.3l-70.9 253.8L445.2 512h39.4L256.4 283.8h254z"/>
          <path fill="#d80027" d="M445.2 256 189.2 0H0v512h445.2l-256-256z"/>
          <path fill="#eee" d="m243.5 378-31.3-14.7L229 333l-34 6.5-4.3-34.3-23.6 25.2-23.7-25.2-4.3 34.3-34-6.5 16.7 30.3L90.4 378l31.3 14.7-16.6 30.3 34-6.5 4.2 34.3 23.7-25.2 23.6 25.2 4.3-34.3 34 6.5-16.7-30.3zM149.8 89l-3.2 25-24.7-4.7 12.1 22-22.7 10.7h-11.1a66.8 66.8 0 0 0 133.5 0h-11.1L200 131.3l12-22-24.6 4.7-3.1-25-17.2 18.4z"/>
        </g>
      </svg>
    }

    <!-- Netherlands -->
    @case ('nl') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ae1c28" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#21468b" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Netherlands Antilles -->
    @case ('an') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h171l85 32 85-32h171v171l-32 85 32 85v171H341l-85-32-85 32H0V341l32-85-32-85Z"/>
          <path fill="#d80027" d="M171 0h170v512H171z"/>
          <path fill="#0052b4" d="M512 171v170H0V171z"/>
          <path fill="#eee" d="m236 247 52-37h-64l52 37-20-61zm-45 79 52-37h-64l52 37-20-61zm90 0 52-37h-64l52 37-20-61zm74-47 52-37h-64l52 37-20-61zm-238 0 52-37h-64l52 37-20-61z"/>
        </g>
      </svg>
    }

    <!-- New Caledonia -->
    @case ('nc') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 352h512v160H0z"/>
          <path fill="#d80027" d="M0 160h512v192H0z"/>
          <path fill="#0052b4" d="M0 0h512v160H0z"/>
          <path fill="#ffda44" d="M398 256a168 168 0 1 1-336 0 168 168 0 0 1 336 0z"/>
          <path fill="#333" d="M230 80a176 176 0 1 0 0 352 176 176 0 0 0 0-352zm-8 16v34c-8 4-14 8-15 16l-1 16 6-3 10-4v8a24 24 0 0 0-16 23 24 24 0 0 0 16 22v8h-20v16h20v8a24 24 0 0 0-16 22 24 24 0 0 0 16 23v7h-20v17h20v7a24 24 0 0 0-16 23 24 24 0 0 0 16 22v8c-10 0-18 3-23 7-7 5-22 20-30 28a160 160 0 0 1 53-308zm16 0a160 160 0 0 1 51 309l-30-29c-5-4-12-6-21-7v-8a24 24 0 0 0 16-22 24 24 0 0 0-16-23v-7h21v-16h-21v-8a24 24 0 0 0 16-23 24 24 0 0 0-16-22v-8h21v-16h-21v-7a24 24 0 0 0 16-23 24 24 0 0 0-16-23v-20c6-5 11-13 17-23 4-8 2-11 2-11l-2 3-17 11V96z"/>
        </g>
      </svg>
    }

    <!-- New Zealand -->
    @case ('nz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Zm382 92-11 35h-37l30 21-12 35 30-22 30 22-12-35 30-21h-37l-11-35Zm61 72-11 35h-37l30 21-11 35 29-21 30 21-12-35 30-21h-37Zm-123 10-11 35h-37l30 22-11 35 29-22 30 22-11-35 29-22h-36zm59 130-11 35h-37l30 21-11 35 29-21 30 21-11-35 29-21h-36z"/><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97zm251 201-5 18h-19l15 10-6 18 15-11 15 11-5-18 14-10h-18Zm-59-129-5 17h-19l15 11-6 17 15-11 15 11-6-17 15-11h-18l-6-17zm123-11-6 18h-18l15 11-6 17 15-11 15 11-6-17 15-11h-18l-6-18zm-61-72-6 17h-18l15 11-6 17 15-10 15 10-6-17 15-11h-18z"/>
        </g>
      </svg>
    }

    <!-- Nicaragua -->
    @case ('ni') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#338af3" d="M0 341.3h512V512H0z"/>
          <!-- emblem omitted for simplicity -->
        </g>
      </svg>
    }

    <!-- Niger -->
    @case ('ne') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ff9811" d="M0 0h512v170.7H0z"/>
          <path fill="#fff" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 341.3h512V512H0z"/>
          <circle cx="256" cy="256" r="40" fill="#ff9811"/>
        </g>
      </svg>
    }

    <!-- Nigeria -->
    @case ('ng') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#008751" d="M0 0h170.7v512H0z"/>
          <path fill="#fff" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#008751" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Niue -->
    @case ('nu') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 256 256 0h256v512H0z" />
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32l42-16 41 16h45l-8-16 8-15v-14l-16-42 16-41V96l-32-32 32-32V0H96L64 32 32 0Z" />
          <path fill="#0052b4" d="M128 256v-83l83 83zm128-45-83-83h83z" />
          <path fill="#d80027" d="m128 128 128 128v-31l-97-97Z" />
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Z" />
          <circle cx="64" cy="64" r="48" fill="#0052b4" />
          <path fill="#ffda44" d="m50 198 14-44 15 44-38-27h47zM162 86l14-44 15 44-38-27h47ZM64 17l28 86-73-53h90l-73 53Z" />
        </g>
      </svg>
    }

    <!-- Norfolk Island -->
    @case ('nf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h144.7l108.4 41.2L367.3 0H512v512H367.3l-110.2-41.4L144.7 512H0z" />
          <path fill="#eee" d="M144.7 0h222.6v512H144.7z" />
          <path fill="#6da544" d="m323 334-67-211.6L189.3 334h50.1v55.7h33.4V334z" />
        </g>
      </svg>
    }

    <!-- Norway -->
    @case ('no') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M144 0h64v512h-64z"/>
          <path fill="#fff" d="M0 224h512v64H0z"/>
          <path fill="#002664" d="M160 0h32v512h-32z"/>
          <path fill="#002664" d="M0 240h512v32H0z"/>
        </g>
      </svg>
    }

    <!-- Oman -->
    @case ('om') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M189.2 0H512v167l-347.5 24.6z" />
          <path fill="#6da544" d="m163 320 349 25v167H189.2z" />
          <path fill="#d80027" d="M0 0h189.2v167H512v178H189.2v167H0z" />
          <path fill="#eee" d="M156.6 112.7 133 89l-15.7 15.8L101.5 89 78 112.7l15.8 15.7L78 144l23.6 23.6 15.8-15.7 15.7 15.7 23.6-23.6-15.7-15.7z" />
        </g>
      </svg>
    }

    <!-- Pakistan -->
    @case ('pk') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#006847" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="M0 0h128v512H0z"/>
          <circle cx="336" cy="256" r="80" fill="#f0f0f0"/>
          <circle cx="352" cy="256" r="64" fill="#006847"/>
          <path fill="#f0f0f0" d="m384 192-14 41h44l-36 26 14 41-36-26-36 26 14-41-36-26h44z"/>
        </g>
      </svg>
    }

    <!-- Palau -->
    @case ('pw') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <circle cx="192" cy="256" r="96" fill="#ffda44"/>
        </g>
      </svg>
    }

    <!-- Palestinian Territory -->
    @case ('ps') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v170.7H0z"/>
          <path fill="#000" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 341.3h512V512H0z"/>
          <path fill="#d80027" d="M0 0v512l256-256z"/>
        </g>
      </svg>
    }

    <!-- Panama -->
    @case ('pa') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h256v256H0zM256 256h256v256H256z"/>
          <path fill="#d80027" d="M0 256h256v256H0z"/>
          <path fill="#0052b4" d="M256 0h256v256H256z"/>
          <path fill="#0052b4" d="m96 96 15.7 48.4H162l-42.3 30.7 15.8 48.4-39.5-28.7-39.6 28.7 15.8-48.4-42.3-30.7h50.3z"/>
          <path fill="#d80027" d="m416 320 15.7 48.4H482l-42.3 30.7 15.8 48.4-39.5-28.7-39.6 28.7 15.8-48.4-42.3-30.7h50.3z"/>
        </g>
      </svg>
    }

    <!-- Papua New Guinea -->
    @case ('pg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#333" d="M512 512 301.3 226.6 0 0v512z" />
          <path fill="#a2001d" d="m0 0 512 512V0z" />
          <path fill="#eee" d="m195 346 4.2 12.9h13.6l-11 8 4.2 12.8-11-7.9-11 7.9 4.2-12.9-11-8h13.6zm-34.6-123.7 7 21.5h22.5L171.7 257l7 21.5-18.3-13.3-18.2 13.3 6.9-21.5-18.2-13.2h22.5zm0 157.4 7 21.5h22.5l-18.2 13.2 7 21.6-18.3-13.4-18.2 13.4 6.9-21.6-18.2-13.2h22.5zm66-101.2 7 21.5H256l-18.2 13.3 6.9 21.4-18.2-13.2-18.3 13.2 7-21.4-18.3-13.3h22.5zm-132 0 7 21.5h22.5l-18.2 13.3 7 21.4-18.3-13.2-18.3 13.2 7-21.4L64.8 300h22.5z" />
          <path fill="#ffda44" d="M430.3 189a67 67 0 0 0-42.6-19.7l48.2-37.6a89.7 89.7 0 0 0-70.3-26A67.2 67.2 0 0 0 348.5 76l-19.2 38.2a28 28 0 0 0-4.8-6.3 28 28 0 1 0-39.7 39.7 28 28 0 0 0 6.3 4.8L253 171.5a67.2 67.2 0 0 0 29.6 17.2 89.7 89.7 0 0 0 26 70.2l42.2-54.2a16.8 16.8 0 0 1 11.9-4.9c4.4 0 8.7 1.7 12 5a16.8 16.8 0 0 1 4.8 11.9c0 4.5-1.7 8.8-4.9 12l15.9 15.9a39.1 39.1 0 0 0 3.7-51.4 44.7 44.7 0 0 1 20.2 11.6 45 45 0 0 1 0 63.6l15.9 15.9a67 67 0 0 0 0-95.4z" />
        </g>
      </svg>
    }

    <!-- Paraguay -->
    @case ('py') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#fff" d="M0 170.7h512v170.6H0z"/>
          <path fill="#0052b4" d="M0 341.3h512V512H0z"/>
          <circle cx="256" cy="256" r="40" fill="#ffda44"/>
        </g>
      </svg>
    }

    <!-- Peru -->
    @case ('pe') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h170.7v512H0zM341.3 0H512v512H341.3z"/>
          <path fill="#fff" d="M170.7 0h170.6v512H170.7z"/>
        </g>
      </svg>
    }

    <!-- Philippines -->
    @case ('ph') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v256l-265 45.2z" />
          <path fill="#d80027" d="M210 256h302v256H0z" />
          <path fill="#eee" d="M0 0v512l256-256z" />
          <path fill="#ffda44" d="M175.3 256 144 241.3l16.7-30.3-34 6.5-4.3-34.3-23.6 25.2L75 183.2l-4.3 34.3-34-6.5 16.7 30.3L22.3 256l31.2 14.7L37 301l34-6.5 4.2 34.3 23.7-25.2 23.6 25.2 4.3-34.3 34 6.5-16.7-30.3zm-107-155.8 10.4 14.5 17-5.4-10.6 14.4 10.4 14.5-17-5.6L68 147l.2-17.9-17-5.6 17-5.4zm0 264.8 10.4 14.6 17-5.4-10.6 14.3 10.4 14.6-17-5.7L68 411.8l.2-17.9-17-5.6 17-5.4zm148.4-132.4L206.3 247l-17-5.4 10.5 14.4-10.4 14.6 17-5.7 10.6 14.4-.1-17.9 17-5.6-17.1-5.4z" />
        </g>
      </svg>
    }

    <!-- Pitcairn -->
    @case ('pn') {
    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z" />
          <path fill="#acabb1" d="m401 156-34 11-33-11-11-28 11-28h67l-11 28Z" />
          <path fill="#338af3" d="M289 156v122c0 60 78 78 78 78s78-18 78-78V156H289z" />
          <path fill="#6da544" d="M296 307c20 37 71 49 71 49s52-12 71-49l-71-118-71 118z" />
          <path fill="#ffda44" d="m445 277-78-121-78 121v1a62 62 0 0 0 7 29l71-110 71 110a62 62 0 0 0 7-29z" />
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z" />
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z" />
        </g>
      </svg>
    }

    <!-- Poland -->
    @case ('pl') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v256H0z"/>
        </g>
      </svg>
    }

    <!-- Portugal -->
    @case ('pt') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 512h167l37.9-260.3L167 0H0z" />
          <path fill="#d80027" d="M512 0H167v512h345z" />
          <circle cx="167" cy="256" r="89" fill="#ffda44" />
          <path fill="#d80027" d="M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z" />
          <path fill="#eee" d="M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z" />
        </g>
      </svg>
    }

    <!-- Puerto Rico -->
    @case ('pr') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v85.3H0zM0 170.7h512v85.3H0zM0 341.3h512v85.4H0zM0 512h512v-85.3H0z"/>
          <path fill="#fff" d="M0 85.3h512v85.4H0zM0 256h512v85.3H0z"/>
          <path fill="#0052b4" d="M0 0v512l256-256z"/>
          <path fill="#fff" d="m96 192 15.7 48.4H162l-42.3 30.7 15.8 48.4-39.5-28.7-39.6 28.7 15.8-48.4-42.3-30.7h50.3z"/>
        </g>
      </svg>
    }

    <!-- Reunion -->
    @case ('re') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M64 0 0 64v160l32 32-32 32v224l256-32 256 32V288l-32-32 32-32V64L448 0H288l-32 32-32-32H64z" />
          <path fill="#d80027" d="M256 256 0 512h512z" />
          <path fill="#ffda44" d="M0 224v64l512-64v64z" />
          <path fill="#ffda44" d="M256 256 0 64V0h64zm0 0L448 0h64v64zm0 0L224 0h64z" />
        </g>
      </svg>
    }

    <!-- Romania -->
    @case ('ro') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h170.7v512H0z"/>
          <path fill="#ffda44" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
        </g>
      </svg>
    }

    <!-- Russian Federation -->
    @case ('ru') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v170.7H0z"/>
          <path fill="#0052b4" d="M0 170.7h512v170.6H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Rwanda -->
    @case ('rw') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="m0 378.5 254.1-22.1L512 378.5V512H0z" />
          <path fill="#ffda44" d="m0 256.1 255-30.3 257 30.3v122.4H0z" />
          <path fill="#338af3" d="M0 0h512v256H0z" />
          <path fill="#ffda44" d="m289.4 150 31.3 14.6L304 195l34-6.5 4.3 34.3 23.6-25.2 23.7 25.2 4.3-34.3 34 6.5-16.7-30.3 31.2-14.7-31.2-14.7 16.6-30.3-34 6.5-4.2-34.3-23.7 25.3-23.6-25.3-4.3 34.3-34-6.5 16.7 30.3z" />
        </g>
      </svg>
    }

    <!-- Qatar -->
    @case ('qa') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#751a46" d="M170.7 0H512v512H170.7z"/>
          <path fill="#f0f0f0" d="m170.7 32 21.3 21.3L170.7 74l21.3 21.3-21.3 21.3L192 138.7l-21.3 21.3L192 181.3l-21.3 21.3L192 224l-21.3 21.3L192 266.7l-21.3 21.3L192 309.3l-21.3 21.3L192 352l-21.3 21.3L192 394.7l-21.3 21.3L192 437.3l-21.3 21.3L192 480l-21.3 21.3H0V0h170.7z"/>
        </g>
      </svg>
    }

    <!-- Saint Helena -->
    @case ('sh') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z" />
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z" />
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z" />
          <path fill="#eee" d="M288 288v32h32v8h96v-8h32v-32h-32v8h-96v-8zm32-144 48-80 48 80z" />
          <circle cx="368" cy="144" r="48" fill="#338af3" />
          <path fill="#338af3" d="M320 144v48l48 32 48-32v-48z" />
          <rect width="32" height="128" x="288" y="128" fill="#ff9811" rx="16" ry="16" />
          <rect width="32" height="128" x="416" y="128" fill="#ff9811" rx="16" ry="16" />
          <path fill="#eee" d="M320 192v29c0 36 48 48 48 48s48-12 48-48v-29zm48-48-16 48h32z" />
          <path fill="#338af3" d="m352 192 16 48 16-48z" />
        </g>
      </svg>
    }

    <!-- Saint Lucia -->
    @case ('lc') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <path fill="#f0f0f0" d="m256 100 80 160H176z"/>
          <path fill="#000" d="m256 144 56 112h-112z"/>
          <path fill="#ffda44" d="m256 192 32 64h-64z"/>
        </g>
      </svg>
    }

    <!-- Saint Pierre and Miquelon -->
    @case ('pm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M160 0h352v512H160l-32-256z" />
          <path fill="#eee" d="m0 160 80-32 80 32v192l-80 32-80-32z" />
          <rect width="160" height="160" fill="#d80027" ry="0" />
          <path fill="#6da544" d="M160 21V0h-20L0 139v21h20z" />
          <path fill="#6da544" d="M0 21V0h20l140 139v21h-20z" />
          <path fill="#eee" d="M0 64h160v32H0z" />
          <path fill="#eee" d="M64 0h32v160H64z" />
          <path fill="#d80027" d="M0 512h160V352H0z" />
          <path fill="#ffda44" d="M340 146v158h-40c-24 0-24-32-24-32h-96v32h20l147 32 145-32v-24h-80s0 24-24 24h-32V146z" />
          <path fill="#ffda44" d="M356 138v32c-31-11-61 8-80-32 33 23 51-10 80 0zm-72 46s-24 24-16 72h-72s32-56 88-72zm16 104h95c-31-48 0-104 0-104h-95s-40 56 0 104zm101-24a96 96 0 0 1 4-64h63s-16 32-1 64zm-101 40h192s-8 0-16 24-16 48-56 48H276c-39 0-52-50-76-72z" />
          <rect width="96" height="32" x="32" y="384" fill="#ffda44" rx="16" ry="16" />
          <rect width="96" height="32" x="32" y="448" fill="#ffda44" rx="16" ry="16" />
        </g>
      </svg>
    }

    <!-- Saint Vincent and the Grenadines -->
    @case ('vc') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h128v512H0z"/>
          <path fill="#ffda44" d="M128 0h256v512H128z"/>
          <path fill="#6da544" d="M384 0h128v512H384z"/>
          <path fill="#6da544" d="M192 256l32 48-32 48-32-48zm64 0l32 48-32 48-32-48zm64 0l32 48-32 48-32-48z"/>
        </g>
      </svg>
    }

    <!-- Samoa -->
    @case ('ws') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#00247d" d="M0 0h256v256H0z"/>
          <path fill="#fff" d="m64 48 9.4 29h30.5l-24.7 17.9 9.4 29-24.7-17.9-24.7 17.9 9.4-29-24.7-17.9h30.5z"/>
        </g>
      </svg>
    }

    <!-- San Marino -->
    @case ('sm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="m0 256 256-52.3L512 256v256H0z" />
          <path fill="#eee" d="M0 0h512v256H0z" />
          <path fill="#6da544" d="M357.6 176.6 256 278.3 154.4 176.6a121.7 121.7 0 0 0-20.8 68.3v33.4c0 53.6 34.6 99.2 82.7 115.8a37 37 0 0 0 4 40l36.4-29.2 36.4 29.2a37 37 0 0 0 3.9-40.5 122.6 122.6 0 0 0 81.4-115.3v-33.4c0-25.3-7.6-48.7-20.8-68.3z" />
          <path fill="#ffda44" d="M256 367.3c-49.1 0-89-40-89-89v-33.4a89.1 89.1 0 0 1 178 0v33.4c0 49-39.9 89-89 89z" />
          <path fill="#338af3" d="M311.7 278.3v-33.4a55.7 55.7 0 0 0-111.4 0v33.4l55.7 11z" />
          <path fill="#6da544" d="M200.3 278.3a55.7 55.7 0 0 0 111.4 0z" />
          <path fill="#ffda44" d="M322.8 155.8A33.4 33.4 0 0 0 267 131v-19.6h11.2V89H267V78h-22v11h-11.2v22.3H245v19.6a33.4 33.4 0 0 0-44.5 49.8v19.6h111.3v-19.6c6.8-6.1 11-15 11-24.9z" />
        </g>
      </svg>
    }

    <!-- Sao Tome and Principe -->
    @case ('st') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v170.7H0z"/>
          <path fill="#ffda44" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 341.3h512V512H0z"/>
          <path fill="#d80027" d="M0 0v512l170.7-256z"/>
          <path fill="#000" d="m304 224 11.8 36.2-31-22.5h38.3l-31 22.5zM416 224l11.8 36.2-31-22.5h38.3l-31 22.5z"/>
        </g>
      </svg>
    }

    <!-- Saudi Arabia -->
    @case ('sa') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h512v512H0z" />
          <g fill="#eee">
            <path d="M144.7 306c0 18.5 15 33.5 33.4 33.5h100.2a27.8 27.8 0 0 0 27.8 27.8h33.4a27.8 27.8 0 0 0 27.8-27.8V306zm225.4-161.3v78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9H370zm-239.3 78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9h-33.4z" />
            <path d="M320 144.7h33.4v78H320zm-50 44.5a5.6 5.6 0 0 1-11.2 0v-44.5h-33.4v44.5a5.6 5.6 0 0 1-11.1 0v-44.5h-33.4v44.5a39 39 0 0 0 39 39 38.7 38.7 0 0 0 22.2-7 38.7 38.7 0 0 0 22.2 7c1.7 0 3.4-.1 5-.3a22.3 22.3 0 0 1-21.6 17v33.4c30.6 0 55.6-25 55.6-55.7v-77.9H270z" />
            <path d="M180.9 244.9h50v33.4h-50z" />
          </g>
        </g>
      </svg>
    }

    <!-- Senegal -->
    @case ('sn') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M341.3 0H512v512H341.3z"/>
          <path fill="#6da544" d="M0 0h170.7v512H0z"/>
          <polygon fill="#0052b4" points="256,160 273.6,212.8 330.5,212.8 284.4,247.2 301.9,300 256,265.6 210.1,300 227.6,247.2 181.5,212.8 238.4,212.8"/>
        </g>
      </svg>
    }

    <!-- Seychelles -->
    @case ('sc') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0v332l150.9-138.5L225.2 0z" />
          <path fill="#ffda44" d="M273.1 253.3 512 0H225.2L0 332v80.2z" />
          <path fill="#d80027" d="M512 0 0 412.2v50.4L277.9 390 512 256z" />
          <path fill="#eee" d="M0 462.6 512 256v133.5l-223.9 78.8L0 488.4z" />
          <path fill="#6da544" d="m512 389.5-512 99V512h512z" />
        </g>
      </svg>
    }

    <!-- Sierra Leone -->
    @case ('sl') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v170.7H0z"/>
          <path fill="#fff" d="M0 170.7h512v170.6H0z"/>
          <path fill="#0052b4" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Singapore -->
    @case ('sg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m0 256 257.7-51L512 256v256H0z" />
          <path fill="#d80027" d="M0 0h512v256H0z" />
          <g fill="#eee">
            <path d="M155.8 133.6A78 78 0 0 1 217 57.5a78.2 78.2 0 0 0-16.7-1.8 78 78 0 1 0 16.7 154 78 78 0 0 1-61.2-76.1zM256 61.2l5.5 17h18l-14.6 10.5 5.6 17L256 95.2l-14.5 10.5 5.6-17-14.5-10.5h17.9z" />
            <path d="m212.6 94.6 5.6 17H236l-14.4 10.5 5.5 17-14.5-10.5-14.4 10.5 5.5-17-14.5-10.5h17.9zm86.8 0 5.5 17h17.9l-14.5 10.5 5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.8zm-16.7 50.1 5.5 17h17.9l-14.5 10.5 5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.9zm-53.4 0 5.5 17h18l-14.5 10.5 5.5 17-14.5-10.5-14.4 10.5 5.5-17-14.5-10.5h17.9z" />
          </g>
        </g>
      </svg>
    }

    <!-- Slovakia -->
    @case ('sk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="m0 160 256-32 256 32v192l-256 32L0 352z" />
          <path fill="#eee" d="M0 0h512v160H0z" />
          <path fill="#d80027" d="M0 352h512v160H0z" />
          <path fill="#eee" d="M64 63v217c0 104 144 137 144 137s144-33 144-137V63z" />
          <path fill="#d80027" d="M96 95v185a83 78 0 0 0 9 34h206a83 77 0 0 0 9-34V95z" />
          <path fill="#eee" d="M288 224h-64v-32h32v-32h-32v-32h-32v32h-32v32h32v32h-64v32h64v32h32v-32h64z" />
          <path fill="#0052b4" d="M152 359a247 231 0 0 0 56 24c12-3 34-11 56-24a123 115 0 0 0 47-45 60 56 0 0 0-34-10l-14 2a60 56 0 0 0-110 0 60 56 0 0 0-14-2c-12 0-24 4-34 10a123 115 0 0 0 47 45z" />
        </g>
      </svg>
    }

    <!-- Slovenia -->
    @case ('si') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z" />
          <path fill="#eee" d="M0 0h512v167H0z" />
          <path fill="#d80027" d="M0 345h512v167H0z" />
          <path fill="#0052b4" d="M222.7 167v-66.8H89V167l67 82.6z" />
          <path fill="#eee" d="M89 167v22.2c0 51.1 66.8 66.8 66.8 66.8s66.8-15.7 66.8-66.8V167l-22.3 22.2-44.5-33.4-44.5 33.4z" />
        </g>
      </svg>
    }

    <!-- Solomon Islands -->
    @case ('sb') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#6da544" d="M0 512 512 0v512z"/>
          <path fill="#ffda44" d="M0 512 512 0v42.7L42.7 512H0z"/>
          <g fill="#fff">
            <circle cx="64" cy="64" r="16"/>
            <circle cx="128" cy="64" r="16"/>
            <circle cx="96" cy="96" r="16"/>
            <circle cx="64" cy="128" r="16"/>
            <circle cx="128" cy="128" r="16"/>
          </g>
        </g>
      </svg>
    }

    <!-- Somalia -->
    @case ('so') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="m256 160 17.8 54.8h57.7l-46.7 34 17.8 54.8-46.6-33.9-46.7 33.9 17.9-54.8-46.7-34h57.8z"/>
        </g>
      </svg>
    }

    <!-- South Africa -->
    @case ('za') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m0 0 192 256L0 512h47l465-189v-34l-32-33 32-33v-34L47 0Z" />
          <path fill="#333" d="M0 142v228l140-114z" />
          <path fill="#ffda44" d="M192 256 0 95v47l114 114L0 370v47z" />
          <path fill="#6da544" d="M512 223H223L0 0v94l161 162L0 418v94l223-223h289z" />
          <path fill="#d80027" d="M512 0H47l189 189h276z" />
          <path fill="#0052b4" d="M512 512H47l189-189h276z" />
        </g>
      </svg>
    }

    <!-- Spain -->
    @case ('es') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#c60b1e" d="M0 0h512v512H0z"/>
          <path fill="#ffc400" d="M0 128h512v256H0z"/>
        </g>
      </svg>
    }

    <!-- Sri Lanka -->
    @case ('lk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#ff9811" d="M81.4 27.2h135.2v456.5H81.4z" />
          <path fill="#6da544" d="m0 44.5 100.2-22v463L0 467.5z" />
          <path fill="#a2001d" d="m218.6 26.5 293.4 18v93.2l-18.6 106.2 18.6 97.4v126.2l-293.4 18z" />
          <path fill="#ffda44" d="M0 0v44.5h200.3v423H0V512h512v-44.5H233.7v-423H512V0z" />
          <path fill="#ffda44" d="M300.5 94.6c-18.4 0-33.4 15-33.4 33.4v144.6a33 33 0 0 0 11.2 25v53h22.2v-27.8h100.2v44.5h-22.3v22.3H423V345l20.4-22.2h48.2a72.9 72.9 0 0 0 20.4 18.5V137.7a66 66 0 0 0-22.5 13.1 67.8 67.8 0 0 0-13.2 82.9c-21.3-.1-41 .2-53.3 0V167c0-11.2-16.7-22.3-16.7-22.3s-16.7 11.1-16.7 22.3h-66.8v66.7h33.4v33.4c0 7.1 1.4 14.1 4.1 20.7L345 300.6h-44.5v-206z" />
        </g>
      </svg>
    }

    <!-- Sudan -->
    @case ('sd') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v170.7H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
          <path fill="#d80027" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 0v512l256-256z"/>
        </g>
      </svg>
    }

    <!-- Suriname -->
    @case ('sr') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M0 128h512v64H0zM0 320h512v64H0z"/>
          <path fill="#6da544" d="M0 192h512v128H0z"/>
          <polygon fill="#ffda44" points="256,192 273.6,244.8 330.5,244.8 284.4,279.2 301.9,332 256,297.6 210.1,332 227.6,279.2 181.5,244.8 238.4,244.8"/>
        </g>
      </svg>
    }

    <!-- Svalbard and Jan Mayen -->
    @case ('sj') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M144 0h64v512h-64zM0 224h512v64H0z"/>
          <path fill="#002664" d="M160 0h32v512h-32zM0 240h512v32H0z"/>
        </g>
      </svg>
    }

    <!-- Swaziland -->
    @case ('sz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="m0 144.7 256-20.5 256 20.5V178l-37.4 79 37.4 77v33.3l-256 24.1L0 367.3V334l37.7-77.3L0 178z" />
          <path fill="#333" d="M0 0h512v144.7H0z" />
          <path fill="#0052b4" d="M0 367.3h512V512H0z" />
          <path fill="#a2001d" d="M0 178h512v156H0z" />
          <path fill="#ffda44" d="M89.2 244.9h334V267h-334zm44.6-44.6h244.8v22.3H133.8z" />
          <path fill="#eee" d="m256.2 189.2-18 65.2 18 68.4c66.8 0 124-66.8 124-66.8s-57.2-66.8-124-66.8z" />
          <path fill="#333" d="M256.2 322.8c-66.8 0-124-66.8-124-66.8s57.2-66.8 124-66.8" />
          <path fill="#eee" d="M211.7 233.7h22.2v44.6h-22.2z" />
          <path fill="#333" d="M278.5 233.7h22.2v44.6h-22.2z" />
          <g fill="#0052b4" transform="translate(.2)">
            <circle cx="89" cy="256" r="22.3" />
            <circle cx="423" cy="256" r="22.3" />
          </g>
        </g>
      </svg>
    }

    <!-- Sweden -->
    @case ('se') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M144 0h64v512h-64zM0 224h512v64H0z"/>
        </g>
      </svg>
    }

    <!-- Switzerland -->
    @case ('ch') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M200 144h112v224H200z"/>
          <path fill="#fff" d="M144 200h224v112H144z"/>
        </g>
      </svg>
    }

    <!-- Syrian Arab Republic -->
    @case ('sy') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
          <g fill="#6da544">
            <polygon points="192,234.7 200.9,260.4 228.4,260.4 206.1,276.2 214.9,301.9 192,286.1 169.1,301.9 177.9,276.2 155.6,260.4 183.1,260.4"/>
            <polygon points="320,234.7 328.9,260.4 356.4,260.4 334.1,276.2 342.9,301.9 320,286.1 297.1,301.9 305.9,276.2 283.6,260.4 311.1,260.4"/>
          </g>
        </g>
      </svg>
    }

    <!-- Taiwan -->
    @case ('tw') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#0052b4" d="M0 0h256v256H0z"/>
          <path fill="#fff" d="m128 64 15.7 48.4H192l-42.3 30.7L165.4 192 128 163.3 90.6 192l15.8-48.9-42.3-30.7h48.3z"/>
        </g>
      </svg>
    }

    <!-- Tajikistan -->
    @case ('tj') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z" />
          <path fill="#d80027" d="M0 0h512v144.7H0z" />
          <path fill="#6da544" d="M0 367.3h512V512H0z" />
          <path fill="#ffda44" d="M211.5 323h89v-38l-17.8 9-26.7-26.9-26.7 26.7-17.8-8.9zm-51-44.6 4.2 12.7H178l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.7-7.9h13.4zm12.9-44.6 4.1 12.8H191l-10.8 8 4.1 12.6-10.8-7.9-10.9 8 4.2-12.8-10.9-8h13.4zm36.7-33.4 4.2 12.8h13.4l-10.9 8 4.2 12.6-11-7.7-10.8 7.8 4.1-12.7-10.8-7.9H206zm141.4 78-4.2 12.7H334l10.9 8-4.2 12.7 10.9-8 10.8 8-4.1-12.8 10.7-7.9h-13.4zm-12.9-44.6-4.1 12.8H321l10.8 8-4.1 12.6 10.8-7.9 10.9 8-4.2-12.8 10.9-8h-13.4zM302 200.4l-4.2 12.8h-13.4l10.9 8-4.2 12.6 10.9-7.7 10.8 7.8-4.1-12.7 10.8-7.9H306zm-46-16.6 4.1 12.7h13.5l-10.9 8 4.1 12.6-10.8-7.8-10.8 7.8 4.1-12.7-10.9-7.9H252z" />
        </g>
      </svg>
    }

    <!-- Tanzania -->
    @case ('tz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h512v512H0z" />
          <path fill="#ffda44" d="M399 0 167 167 0 399v45l68 68h45l232-167 167-232V68L444 0Z" />
          <path fill="#333" d="M444 0 0 444v68h68L512 68V0Z" />
          <path fill="#338af3" d="m113 512 399-399v399z" />
          <path fill="#6da544" d="M0 399V0h399Z" />
        </g>
      </svg>
    }

    <!-- Thailand -->
    @case ('th') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M0 0h512v128H0zM0 384h512v128H0z"/>
          <path fill="#0052b4" d="M0 192h512v128H0z"/>
        </g>
      </svg>
    }

    <!-- Timor-Leste -->
    @case ('tl') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M0 0v512l256-256z"/>
          <path fill="#000" d="M0 0v512l160-256z"/>
          <path fill="#fff" d="m64 192 19 58.6h61.6l-49.8 36.2 19 58.6-49.8-36.2-49.8 36.2L64 287l-49.8-36.2h61.6z"/>
        </g>
      </svg>
    }

    <!-- Togo -->
    @case ('tg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M256 0h256v102.4L483.8 151l28.2 53.8v102.4l-30.5 50.7 30.5 51.7V512H0V409.6l34.7-51L0 307.1z" />
          <path fill="#ff9811" d="M0 44.5v423V256z" />
          <path fill="#ffda44" d="M231.7 102.4v102.4H512V102.4zM0 307.2v102.4h512V307.2H256l-128.2-26.4z" />
          <path fill="#d80027" d="M256 307.2V0H0v307.2z" />
          <path fill="#eee" d="m141.4 122.4 16.5 51h53.7L168 205l16.6 51-43.4-31.5L98 256l16.5-51L71 173.5h53.7z" />
        </g>
      </svg>
    }

    <!-- Tokelau -->
    @case ('tk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v512H0z" />
          <path fill="#eee" d="m188 133.6 5.6 17h17.9L197 161l5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.8zM115.5 256l7 21.3h22.3l-18 13 6.8 21.4-18-13.2-18.1 13.2 6.9-21.3-18.1-13.1h22.3zm0-178 7 21.2h22.3l-18 13.1 6.8 21.3-18-13.2-18.1 13.2 6.9-21.3-18.1-13.1h22.3zM59.8 178l6.9 21.3H89l-18 13.2 6.9 21.2-18.1-13.1-18.1 13.1 7-21.2-18.2-13.2H53z" />
          <path fill="#ffda44" d="M411.8 122.4 144.7 345h361.7v-35.8a167.4 167.4 0 0 1-97.9-152.3c0-11.7 1-23.5 3.3-34.5zm94.6 244.9H144.7v33.4h361.7z" />
        </g>
      </svg>
    }

    <!-- Tonga -->
    @case ('to') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M0 0h192v192H0z"/>
          <path fill="#d80027" d="M72 48h48v96H72zM48 72h96v48H48z"/>
        </g>
      </svg>
    }

    <!-- Trinidad and Tobago -->
    @case ('tt') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#fff" d="M0 0 512 512h-64L0 64z"/>
          <path fill="#000" d="M0 0 512 512h-32L0 32z"/>
        </g>
      </svg>
    }

    <!-- Tunisia -->
    @case ('tn') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <circle cx="256" cy="256" r="96" fill="#fff"/>
          <circle cx="272" cy="256" r="64" fill="#d80027"/>
          <path fill="#fff" d="m304 224-14 43h44l-36 26 14 43-36-26-36 26 14-43-36-26h44z"/>
        </g>
      </svg>
    }

    <!-- Turkey -->
    @case ('tr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z" />
          <g fill="#eee">
            <path d="m350 182 33 46 54-18-33 46 33 46-54-18-33 46v-57l-54-17 54-18v-56Z" />
            <path d="M260 370a114 114 0 1 1 54-215 141 141 0 1 0 0 202c-17 9-35 13-54 13Z" />
          </g>
        </g>
      </svg>
    }

    <!-- Turkmenistan -->
    @case ('tm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h66.8l67.8 32.3L200.3 0H512v512H200.3l-70.2-34.1L66.8 512H0z" />
          <path fill="#d80027" d="M66.8 0h133.5v512H66.8z" />
          <g fill="#eee">
            <path d="M374.4 193.1a78 78 0 0 0-31.9-92.3 78.2 78.2 0 0 1 16.3 4 78 78 0 1 1-52.6 146.6 78.1 78.1 0 0 1-15.1-7.3 78 78 0 0 0 83.3-51zm-69.8-102-11 14.2-16.8-6 10 14.8-10.9 14 17.2-5 10 14.9.6-18 17.2-5-16.9-6z" />
            <path d="m334.1 137.3-11 14-16.8-6 10.1 14.8-11 14.2 17.2-5 10.1 14.7.5-17.8 17.2-5-16.8-6zM252.5 108l-11 14.1-16.8-6 10 14.7-10.9 14.2 17.2-5 10 14.7.6-17.8 17.1-5-16.8-6zm-1.2 52.7-11 14.2-16.8-6 10 14.7-10.9 14.2 17.2-5 10 14.7.6-17.8 17.1-5-16.8-6zm50.2 18-11 14.2-16.8-6 10 14.7-10.9 14.2 17.2-5 10 14.7.6-17.8 17.2-5-16.9-6z" />
          </g>
          <path fill="#eee" d="M117.8 134.8 95.4 118v-12l38.2-28 15.8-.1 22.3 16.7v11.5l-38.1 28.7z" />
          <path fill="#ff9811" d="M133.6 78h-15.8L95.4 94.5V106h38.2zm0 56.8h15.8l22.3-16.7v-12h-38.1z" />
          <path fill="#496e2d" d="m117.8 284.4-22.4-16.6v-23.6l22.4-16.6h31.6l22.3 16.6v23.6l-22.3 16.6zm54.7 36.7h-9.7v-9.8h-17.1l-12.1-12-12.1 12h-17.2v9.8h-9.7v19.5h9.7v9.7h17.2l12 12.1 12.2-12.1h17v-9.7h9.8zm0-149.7h-9.7v-9.7h-17.1l-12.1-12.1-12.1 12h-17.2v9.8h-9.7V191h9.7v9.8h17.2l12 12 12.2-12h17V191h9.8z" />
          <g fill="#d80027">
            <path d="M122.4 244.9h22.3V267h-22.3z" />
            <circle cx="133.6" cy="181.2" r="11.1" />
            <circle cx="133.6" cy="330.8" r="11.1" />
          </g>
          <path fill="#eee" d="m117.8 434-22.4-16.8v-12l38.2-28 15.8-.1 22.3 16.7v11.5L133.6 434z" />
          <path fill="#ff9811" d="M133.6 377.2h-15.8l-22.4 16.5v11.5h38.2zm0 56.8h15.8l22.3-16.7v-12h-38.1z" />
        </g>
      </svg>
    }

    <!-- Turks and Caicos Islands -->
    @case ('tc') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z" />
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z" />
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z" />
          <path fill="#ffda44" d="M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z" />
          <path fill="#ff9811" d="M356.2 178c0 12.4-10 44.6-22.3 44.6s-22.2-32.2-22.2-44.5c0-12.3 22.2-22.3 22.2-22.3s22.3 10 22.3 22.3z" />
          <path fill="#a2001d" d="M415.2 202.3a92.2 92.2 0 0 0 6.4-28c0-10.2-13.3-18.5-13.3-18.5s-13.4 8.3-13.4 18.6c0 6.4 2.8 19.2 6.4 28l-7.7 17.3a38.9 38.9 0 0 0 14.7 3 38.9 38.9 0 0 0 14.7-3z" />
          <path fill="#6da544" d="M350.6 256s-11.1 22.3-11.1 44.5H395c0-22.2-11.1-44.5-11.1-44.5l-16.7-11.1-16.7 11.1Z" />
          <path fill="#d80027" d="M384 256v-5.6a16.7 16.7 0 0 0-33.4 0v5.6z" />
        </g>
      </svg>
    }

    <!-- Tuvalu -->
    @case ('tv') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 256 256 0h256v512H0z" />
          <path fill="#eee" d="M0 0h33.4l32 16.9L100.3 0H256v33.4l-14.8 33.5 14.8 33.3v33.4l-9.3 33.7 9.3 41.5v15.7l-6.2 11.6L256 256h-47.2l-39.3-7-35.9 7.1-33.4-.1-32.6-16.6L33.4 256H0V100.2l14.2-35.8L0 33.4z" />
          <path fill="#d80027" d="m256 224.5-91-91h-31.4L256 256z" />
          <path fill="#d80027" d="M33.4 0v33.4H0v66.8h33.4V256h66.8V100.2H256V33.4H100.2V0z" />
          <path fill="#ffda44" d="m279.4 423 5.5 17h18l-14.6 10.5 5.6 17-14.5-10.5-14.5 10.5 5.6-17L256 440h17.9zm142.4-111.3 5.5 17h18l-14.5 10.5 5.5 17-14.5-10.5-14.5 10.5 5.6-17-14.5-10.5h17.9zm35.7-167 5.5 17h18l-14.5 10.5 5.6 17-14.5-10.5-14.5 10.5 5.6-17-14.5-10.5H452zm8.8 122.4 5.6 17h17.8l-14.4 10.5 5.5 17-14.5-10.5-14.4 10.6 5.5-17-14.5-10.6h18zM305 383l16 8 12.6-12.6-2.8 17.7 16 8.1L329 407l-2.8 17.7-8.1-16-17.7 2.8 12.7-12.6zm0-66.8 16 8.1 12.6-12.6-2.8 17.6 16 8.1-17.7 2.8-2.8 17.7-8.1-16-17.7 2.9 12.7-12.7zm55.7 42.8 16 8.1 12.6-12.6-2.8 17.6 16 8.1-17.8 2.8-2.7 17.7-8.2-16-17.6 2.9 12.6-12.7zm0-143 16 8.1 12.6-12.6-2.8 17.6 16 8.2-17.8 2.8-2.7 17.6-8.2-16-17.6 2.9 12.6-12.7zm54-1.7 15.9 8.1 12.6-12.6-2.8 17.6 16 8.1-17.7 2.8-2.8 17.7-8.1-16-17.8 3 12.7-12.7z" />
          <path fill="#0052b4" d="M180.8 133.6H256v75.2zm-47.2 47.2v75.3l75.2-.1z" />
        </g>
      </svg>
    }

    <!-- Uganda -->
    @case ('ug') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v85.3H0z"/>
          <path fill="#000" d="M0 85.3h512v85.3H0z"/>
          <path fill="#d80027" d="M0 170.6h512v85.3H0z"/>
          <path fill="#ffda44" d="M0 255.9h512v85.3H0z"/>
          <path fill="#000" d="M0 341.2h512v85.3H0z"/>
          <path fill="#d80027" d="M0 426.5h512V512H0z"/>
          <circle cx="256" cy="256" r="64" fill="#fff"/>
          <!-- Crested crane omitted for simplicity -->
        </g>
      </svg>
    }

    <!-- Ukraine -->
    @case ('ua') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v256H0z"/>
          <path fill="#ffda44" d="M0 256h512v256H0z"/>
        </g>
      </svg>
    }

    <!-- United Kingdom -->
    @case ('gb') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m0 0 8 22-8 23v23l32 54-32 54v32l32 48-32 48v32l32 54-32 54v68l22-8 23 8h23l54-32 54 32h32l48-32 48 32h32l54-32 54 32h68l-8-22 8-23v-23l-32-54 32-54v-32l-32-48 32-48v-32l-32-54 32-54V0l-22 8-23-8h-23l-54 32-54-32h-32l-48 32-48-32h-32l-54 32L68 0H0z" />
          <path fill="#0052b4" d="M336 0v108L444 0Zm176 68L404 176h108zM0 176h108L0 68ZM68 0l108 108V0Zm108 512V404L68 512ZM0 444l108-108H0Zm512-108H404l108 108Zm-68 176L336 404v108z" />
          <path fill="#d80027" d="M0 0v45l131 131h45L0 0zm208 0v208H0v96h208v208h96V304h208v-96H304V0h-96zm259 0L336 131v45L512 0h-45zM176 336 0 512h45l131-131v-45zm160 0 176 176v-45L381 336h-45z" />
        </g>
      </svg>
    }

    <!-- United States -->
    @case ('us') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M256 0h256v64l-32 32 32 32v64l-32 32 32 32v64l-32 32 32 32v64l-256 32L0 448v-64l32-32-32-32v-64z" />
          <path fill="#d80027" d="M224 64h288v64H224Zm0 128h288v64H256ZM0 320h512v64H0Zm0 128h512v64H0Z" />
          <path fill="#0052b4" d="M0 0h256v256H0Z" />
          <path fill="#eee" d="m187 243 57-41h-70l57 41-22-67zm-81 0 57-41H93l57 41-22-67zm-81 0 57-41H12l57 41-22-67zm162-81 57-41h-70l57 41-22-67zm-81 0 57-41H93l57 41-22-67zm-81 0 57-41H12l57 41-22-67Zm162-82 57-41h-70l57 41-22-67Zm-81 0 57-41H93l57 41-22-67zm-81 0 57-41H12l57 41-22-67Z" />
        </g>
      </svg>
    }

    <!-- United States Minor Outlying Islands -->
    @case ('um') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M0 0h512v36.6H0zM0 73.2h512v36.6H0zM0 146.4h512v36.6H0zM0 219.6h512v36.6H0zM0 292.8h512v36.6H0zM0 366h512v36.6H0zM0 439.2h512v36.6H0z"/>
          <path fill="#0052b4" d="M0 0h204.8v219.6H0z"/>
        </g>
      </svg>
    }

    <!-- Uruguay -->
    @case ('uy') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 256 256 0h256v55.7l-20.7 34.5 20.7 32.2v66.8l-21.2 32.7L512 256v66.8l-24 31.7 24 35.1v66.7l-259.1 28.3L0 456.3v-66.7l27.1-33.3L0 322.8z" />
          <path fill="#eee" d="M256 256h256v-66.8H236.9zm-19.1-133.6H512V55.7H236.9zM512 512v-55.7H0V512zM0 389.6h512v-66.8H0z" />
          <path fill="#eee" d="M0 0h256v256H0z" />
          <path fill="#ffda44" d="m222.6 149.8-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-33.9 6.5 16.6-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.2-34.3 23.7 25.3L169.7 77l4.3 34.3 34-6.5-16.7 30.3z" />
        </g>
      </svg>
}

    <!-- Uzbekistan -->
    @case ('uz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="m0 178 254.2-22L512 178v22.3l-40.2 54.1 40.2 57.3V334l-254 23.4L0 334v-22.3l36.7-59.4-36.7-52z" />
          <path fill="#338af3" d="M0 0h512v178H0z" />
          <path fill="#eee" d="M0 200.3h512v111.4H0z" />
          <path fill="#6da544" d="M0 334h512v178H0z" />
          <path fill="#eee" d="M117.2 105.7a50 50 0 0 1 39.3-48.9 50.2 50.2 0 0 0-10.7-1.1 50 50 0 1 0 10.7 99c-22.5-5-39.3-25-39.3-49zm69 22.8 3.3 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.7 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.4 10.4-8.8-6.4-9 6.4 3.5-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-8.8-6.5h11zm-105-36.4 3.4 10.4h11l-9 6.5 3.4 10.4-8.8-6.5-9 6.5 3.5-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-8.8-6.5h11zm-70-36.4 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-9-6.4h11zm35 0 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-9-6.4h11zm35 0 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-8.8-6.4h11z" />
        </g>
      </svg>
    }

    <!-- Vanuatu -->
    @case ('vu') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M512 222.6V0H0l215.6 239.4z" />
          <path fill="#6da544" d="M512 289.4V512H0l216.5-240z" />
          <path fill="#333" d="m0 0 222.6 222.6H512v22.2l-10.9 11.8L512 267v22.4H222.6L0 512v-31.5l8-23-8-8.6V63l9.5-10.4-9.5-21z" />
          <g fill="#ffda44">
            <path d="M512 244.8H213.2L0 31.7V63l192.8 193L0 449v31.5L213.2 267H512z" />
            <path d="M62.2 310.6V289a38.8 38.8 0 0 0 38.8-38.8A27.5 27.5 0 0 0 73.5 223a18.7 18.7 0 0 0-18.7 18.7 12 12 0 0 0 12 12c3.7 0 6.8-3 6.8-6.8H95A28.2 28.2 0 0 1 66.8 275c-18.4 0-33.4-15-33.4-33.4 0-22.2 18-40.2 40-40.2a49 49 0 0 1 49 49c0 33.1-27 60.2-60.2 60.2z" />
          </g>
        </g>
      </svg>
    }

    <!-- Venezuela -->
    @case ('ve') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z" />
          <path fill="#ffda44" d="M0 0h512v144.7H0z" />
          <path fill="#d80027" d="M0 367.3h512V512H0z" />
          <path fill="#eee" d="M443.4 306.4 429.8 317l6 16.1-14.3-9.6-13.5 10.7 4.7-16.5-14.2-9.6 17.1-.6 4.7-16.5 6 16.1zm-34.7-60-9 14.5 11 13.2L394 270l-9 14.6-1.3-17-16.6-4.3 15.9-6.4-1.2-17 11 13zm-53-44.5-3.6 16.8 14.9 8.4-17 1.8-3.6 16.8-7-15.7-17 1.8 12.7-11.5-7-15.6 14.8 8.6zm-65-23.7 2.3 17 17 3-15.5 7.5 2.4 17-12-12.4-15.4 7.6 8-15.2-11.8-12.3 16.9 3zm-69.3 0 8 15.1 17-3-12 12.4 8 15.2-15.4-7.6-11.9 12.4 2.4-17-15.4-7.5 16.9-3zm-65 23.7 12.7 11.5 14.8-8.6-7 15.7 12.8 11.4-17-1.8-7 15.7-3.7-16.7-17-1.8 14.8-8.5zm-53.1 44.5 15.9 6.4 11-13-1.2 17 16 6.4-16.7 4.2-1.2 17L118 270l-16.7 4.2 11-13.2zm-34.7 60 17.2.5 5.9-16 4.7 16.4 17.1.6-14.2 9.6 4.7 16.6-13.5-10.6-14.2 9.6 5.9-16z" />
        </g>
      </svg>
    }

    <!-- Viet Nam -->
    @case ('vn') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="m256 128 23.5 72.3H352l-59.8 43.4 23.5 72.3-59.7-43.4-59.7 43.4 23.5-72.3-59.8-43.4h72.5z"/>
        </g>
      </svg>
    }

    <!-- Virgin Islands, British -->
    @case ('vg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z" />
          <path fill="#ffda44" d="m367.3 256-69.2 69.2a77.9 77.9 0 0 0 138.4 0z" />
          <path fill="#6da544" d="M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z" />
          <path fill="#496e2d" d="M445.2 256zm-155.8 0z" />
          <path fill="#ffda44" d="M311.7 155.8h22.2v22.3h-22.2zm0 50.1h22.2v22.3h-22.2zm0 50.1h22.2v22.3h-22.2zm89-100.2H423v22.3h-22.3zm0 50.1H423v22.3h-22.3zm0 50.1H423v22.3h-22.3z" />
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z" />
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z" />
          <path fill="#eee" d="M350.6 189.2H384v89h-33.4z" />
          <circle cx="367.3" cy="189.2" r="16.7" fill="#a2001d" />
        </g>
      </svg>
    }

    <!-- Virgin Islands, U.S. -->
    @case ('vi') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h512v512H0z" />
          <g fill="#ffda44">
            <path d="M299.5 178.8a43.5 43.5 0 1 0-87 0H117a44 44 0 0 0 44.2 42.9h-1.4a42.8 42.8 0 0 0 42.8 42.8l53.5 42 53.5-42a42.8 42.8 0 0 0 42.8-42.8H351a44 44 0 0 0 44.2-42.9h-95.6z"/>
            <path d="m236.9 302.3-27 60.9a122 122 0 0 0 46.1 9 122 122 0 0 0 46-9l-26.9-60.9H237z"/>
          </g>
          <path fill="#eee" d="m255.3 214-55 21.5v39.7a49.1 49.1 0 0 0 22.3 40l11.3-2.3 11 14.3a98.2 98.2 0 0 0 11.1 3.6s4.6-1.1 11.1-3.6l9.4-14.1 13 2.1a49.2 49.2 0 0 0 22.2-40.1v-39.6z"/>
          <path fill="#338af3" d="M62 257.8 92.3 342l29.8-84.2h22.7l-43.4 111.3H83L39.3 257.8h22.8zm349.8 111.3V257.8h21.7v111.3z"/>
          <path fill="#d80027" d="M222.6 224.4v90.8a96 96 0 0 0 22.3 12V224.3zm66.8 0v90.8a98 98 0 0 1-22.3 12V224.3z"/>
          <path fill="#0052b4" d="M200.3 200.2h111.4v35.3H200.3z"/>
        </g>
      </svg>
    }

    <!-- Wallis and Futuna -->
    @case ('wf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M256 0h256v512H0V256Z" />
          <path fill="#eee" d="M0 0h256v256H0Z" />
          <path fill="#0052b4" d="M0 0h75v224H0Z" />
          <path fill="#d80027" d="M149 0h75v224h-75z" />
          <path fill="#eee" d="m384 232-72-72h144zm-24 24-72-72v144zm24 24-72 72h144zm24-24 72-72v144z" />
        </g>
      </svg>
    }

    <!-- Western Sahara -->
    @case ('eh') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m90.1 144.8 210.5-27.7L512 144.8v222.6l-209 32.4-213-32.4z" />
          <path fill="#333" d="M0 0h512v144.8H28.2z" />
          <path fill="#496e2d" d="M39.5 367.4H512V512H0z" />
          <path fill="#d80027" d="M0 .1V512h.1L256 256.1 0 .1zm365.1 178.1a78 78 0 1 0 18.9 154 78 78 0 0 1 0-152.2 78.2 78.2 0 0 0-18.9-1.8z" />
          <path fill="#d80027" d="m387.3 206.1 11 34h35.8l-29 21 11.1 34-29-21-28.9 21 11.1-34-29-21h35.8z" />
        </g>
      </svg>
    }

    <!-- Yemen -->
    @case ('ye') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Zambia -->
    @case ('zm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h512v256L256 512H0z" />
          <path fill="#ff9811" d="M473 167h-66.7a22.3 22.3 0 0 0-44.6 0H295a23 23 0 0 0 23 22.2h-.8c0 12.3 10 22.3 22.3 22.3 0 12.3 10 22.2 22.2 22.2h44.6c12.3 0 22.2-10 22.2-22.2 12.3 0 22.3-10 22.3-22.3h-.8a23 23 0 0 0 23-22.2z" />
          <path fill="#333" d="M341.3 256h85.4l21.1 126.3L426.7 512h-85.4l-23.5-128z" />
          <path fill="#d80027" d="M256 256h85.3v256H256z" />
          <path fill="#ff9811" d="M426.7 256H512v256h-85.3z" />
        </g>
      </svg>
    }

    <!-- Zimbabwe -->
    @case ('zw') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#006400" d="M0 0h512v85.3H0z"/>
          <path fill="#ffda44" d="M0 85.3h512v85.4H0z"/>
          <path fill="#d80027" d="M0 170.7h512v85.3H0z"/>
          <path fill="#000" d="M0 256h512v85.3H0z"/>
          <path fill="#ffda44" d="M0 341.3h512v85.4H0z"/>
          <path fill="#006400" d="M0 426.7h512V512H0z"/>
          <path fill="#fff" d="M0 0v512l256-256z"/>
          <path fill="#d80027" d="m128 192 14.1 43.4h45.6l-36.9 26.8 14.1 43.4-36.9-26.8-36.9 26.8 14.1-43.4-36.9-26.8h45.6z"/>
        </g>
      </svg>
    }

    <!-- Afghanistan -->
    @case ('af') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#000" d="M0 0h170.7v512H0z"/>
          <path fill="#d80027" d="M170.7 0h170.6v512H170.7z"/>
          <path fill="#496e2d" d="M341.3 0H512v512H341.3z"/>
          <!-- Emblem omitted -->
        </g>
      </svg>
    }

    <!-- Bosnia and Herzegovina -->
    @case ('ba') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h445.3l33.9 255-33.9 257-323.7-134.3L0 66.8z" />
          <path fill="#0052b4" d="M0 66.8V512h445.4z" />
          <path fill="#0052b4" d="M445.3 0H512v512h-66.7z" />
          <path fill="#eee" d="m354.6 456-8.3 25.6h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zm-55-55.4-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zM244.4 345l-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zm-55.1-55.7-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8L211 356l-8.3-25.5 21.7-15.8h-26.8zm-55.4-55.7-8.3 25.5H98.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5L169 259h-26.8zM78.7 178l-8.3 25.5H43.6l21.7 15.8-8.3 25.5L78.7 229l21.7 15.8-8.3-25.5 21.7-15.8H87zm-55.2-55.7-8.3 25.5h-26.8l21.7 15.8L1.8 189l21.7-15.8L45.2 189l-8.3-25.5 21.7-15.8H31.8z" />
        </g>
      </svg>
    }

    <!-- Liechtenstein -->
    @case ('li') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h512v256H0z"/>
          <path fill="#d80027" d="M0 256h512v256H0z"/>
          <path fill="#ffda44" d="M96 128a32 32 0 1 1 64 0v16h-64z"/>
        </g>
      </svg>
    }

    <!-- Luxembourg -->
    @case ('lu') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#f0f0f0" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#338af3" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Macao -->
    @case ('mo') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h512v512H0z" />
          <path fill="#eee" d="M300.5 245.3c-6.3 0-12.2 1.3-17.8 3.3 3-6.8 5.1-14.3 5.1-22.4 0-31.8-31.8-55.6-31.8-55.6s-31.8 23.8-31.8 55.6c0 8 2 15.6 5 22.4-5.5-2-11.4-3.3-17.7-3.3-31.8 0-55.7 31.8-55.7 31.8s23.9 31.8 55.7 31.8C230 309 246 298 256 289c10 9.1 25.9 20 44.5 20 31.8 0 55.7-31.8 55.7-31.8s-23.9-31.8-55.7-31.8z" />
          <path fill="#ffda44" d="m256 100.2 6.6 20.2h21.2l-17.2 12.5 6.6 20.2-17.2-12.5-17.2 12.5 6.6-20.2-17.2-12.5h21.2zm-80.8 35.3 12.6 11.4 14.7-8.5-6.9 15.5 12.7 11.4-17-1.8-6.9 15.6-3.5-16.7-17-1.7 14.8-8.5zM116 194.7l16.6 3.5 8.5-14.7 1.8 17 16.6 3.5-15.5 6.9 1.8 16.9-11.4-12.6-15.5 6.9 8.5-14.8zm220.8-59.2L324.2 147l-14.7-8.5 6.9 15.5-12.7 11.4 17-1.8 6.9 15.6 3.5-16.7 17-1.7-14.8-8.5zm59.2 59.2-16.6 3.5-8.5-14.7-1.8 17-16.6 3.5 15.5 6.9-1.8 16.9 11.4-12.6 15.5 6.9-8.5-14.8z" />
          <path fill="#eee" d="M256 398c25.3 0 48.5-8.5 67.2-22.6H188.8c18.7 14.1 42 22.6 67.2 22.6zm-102-66.8a111.3 111.3 0 0 0 13.2 22.6h177.6a111.3 111.3 0 0 0 13.2-22.6z" />
        </g>
      </svg>
    }

    <!-- Marshall Islands -->
    @case ('mh') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M0 0h397.6L512 114.2V512H0z" />
          <path fill="#eee" d="M512 0H397.6L0 512 493.4 53.7z" />
          <path fill="#ff9811" d="m0 512 512-397.8V0z" />
          <path fill="#eee" d="M222.2 150.1 191 164.8l16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-33.9 6.5 16.6-30.3-31.2-14.7 31.2-14.7L84 105.1l34 6.5 4.2-34.3 23.7 25.3 23.6-25.3 4.3 34.3 34-6.5-16.7 30.3z" />
        </g>
      </svg>
    }

    <!-- Martinique -->
    @case ('mq') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v256l-256 44Z" />
          <path fill="#333" d="M210 256h302v256H0z" />
          <path fill="#d80027" d="M0 0v512l256-256L0 0z" />
        </g>
      </svg>
    }

    <!-- Mauritania -->
    @case ('mr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h512v512H0z" />
          <g fill="#ffda44">
            <path d="M256 295.8a89 89 0 0 1-87-70 89.4 89.4 0 0 0-2 19 89 89 0 1 0 178 0 89.4 89.4 0 0 0-2-19 89 89 0 0 1-87 70z" />
            <path d="m256 178 8.3 25.6H291l-21.7 15.8 8.3 25.5L256 229l-21.7 15.8 8.3-25.5-21.7-15.8h26.8z" />
          </g>
        </g>
      </svg>
    }

    <!-- Antigua and Barbuda -->
    @case ('ag') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v170.7H0z"/>
          <path fill="#0052b4" d="M0 170.7h512v85.3H0z"/>
          <path fill="#f0f0f0" d="M0 256h512v85.3H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
          <path fill="#ffda44" d="M256 128 234 176h44zM218 144l-20 30h40zm76 0-20 30h40z"/>
          <path fill="#ffda44" d="m256 224-256 192h512z"/>
        </g>
      </svg>
    }

    <!-- Cocos (Keeling) Islands -->
    @case ('cc') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v512H0z" />
          <g fill="#ffda44">
            <path d="m393 367.3 7 14.7 15.9-3.7-7.1 14.7 12.7 10-15.9 3.7V423L393 412.8 380.3 423v-16.3l-15.9-3.6 12.8-10.1-7.1-14.7L386 382zm-65.4-155.8 7 14.7 16-3.7-7.2 14.7 12.8 10-16 3.6.1 16.3-12.7-10.2-12.7 10.2v-16.3l-15.8-3.5 12.7-10.1-7-14.7 15.8 3.7zm65.4-89 7 14.6 15.9-3.6-7.1 14.6 12.7 10.1-15.9 3.6v16.3L393 167.9l-12.7 10.2v-16.3l-15.9-3.6 12.8-10-7.1-14.7L386 137zm57 66.7 7 14.7 16-3.7-7.1 14.7 12.7 10.1-15.9 3.6v16.3l-12.6-10.2-12.7 10.2v-16.3l-15.9-3.6 12.8-10.1-7.1-14.7L443 204zm-40.8 78 5.6 17h17.9l-14.5 10.4 5.5 17-14.5-10.5-14.4 10.6 5.5-17-14.5-10.6h18z" />
            <path d="M283.8 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7zM161 100.2a44.5 44.5 0 0 0-77.1 0h77zm.1.2-38.7 38.7-38.7-38.7a44.3 44.3 0 0 0-5.8 22 44.5 44.5 0 1 0 89 0 44.3 44.3 0 0 0-5.8-22z" />
          </g>
          <path fill="#a2001d" d="M111.3 128v37.6a44.6 44.6 0 0 0 11.1 1.4c3.9 0 7.6-.5 11.2-1.4V128h-22.3z" />
        </g>
      </svg>
    }

    <!-- Equatorial Guinea -->
    @case ('gq') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
          <path fill="#f0f0f0" d="M0 170.7h512v170.6H0z"/>
          <path fill="#6da544" d="M0 0h512v170.7H0z"/>
          <path fill="#0052b4" d="M0 0v512l170.7-256z"/>
        </g>
      </svg>
    }

    <!-- Guadeloupe -->
    @case ('gp') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path fill="#333" d="M0 176h512v336H0z" />
          <path fill="#0052b4" d="M0 0h512v176H0z" />
          <path fill="#6da544" d="M94 228a8 8 0 0 0-2 0 8 8 0 0 0-5 4 8 8 0 0 0-1 6l7 25-39-23a8 8 0 0 0-11 3 8 8 0 0 0 3 11l39 23-25 6a8 8 0 0 0-5 4 8 8 0 0 0-1 6 8 8 0 0 0 10 6l41-11 8 5-26 6a8 8 0 0 0-4 4 8 8 0 0 0-1 6 8 8 0 0 0 10 6l40-11 8 5-25 6a8 8 0 0 0-4 4 8 8 0 0 0-1 6 8 8 0 0 0 10 6l40-11 25 14a8 8 0 0 0 11-3 8 8 0 0 0-3-10l-25-15-11-40a8 8 0 0 0-10-6 8 8 0 0 0-5 4 8 8 0 0 0 0 6l6 25-8-5-11-40a8 8 0 0 0-9-6 8 8 0 0 0-5 4 8 8 0 0 0-1 6l7 25-8-5-11-40a8 8 0 0 0-8-6zm180 96 122 107c17-13 32-30 44-48l-166-59z" />
          <path fill="#ffda44" d="m256 480-21-29-31 19-8-35-36 5 6-35-36-9 19-31-29-21 29-21-19-31 36-8-6-36 36 6 8-36 31 19 21-29 21 29 31-19 8 36 36-6-6 36 36 8-19 31 29 21-29 21 19 31-36 8 6 36-36-5-8 35-31-19zm0-440-10 11c-7 11-9 22-5 31l7 17c-4-6-9-10-15-12-4-1-11 0-16 5-7 6-10 24 11 27-2-3-2-9 3-11 3-2 7-1 8 0 2 1 4 4 5 7h-5v10h6c-2 6-6 9-15 16 8 1 17-5 19-7l2-5-1 20c1 5 2 7 6 11 4-4 5-6 6-11l-1-20 2 4c2 3 11 9 19 9-9-8-13-11-14-17h5v-10h-5c1-3 3-6 5-7 1-1 5-2 9 0s4 8 2 11c21-3 18-21 11-27-5-5-11-6-16-5-6 2-11 6-15 12l7-17c4-9 2-20-5-31l-10-11zm96 0-10 11c-7 11-9 22-5 31l7 17c-4-6-9-10-15-12-5-1-11 0-17 5-6 6-9 24 12 27-2-3-2-9 3-11 3-2 7-1 8 0 2 1 4 4 5 7h-5v10h5c-1 6-5 9-14 16 8 1 17-5 19-7l2-5-1 20c1 5 2 7 6 11 4-4 5-6 6-11l-1-20 2 4c2 3 11 9 19 9-9-8-13-11-15-17h6v-10h-5c1-3 3-6 5-7 1-1 5-2 8 0 5 2 5 8 3 11 21-3 18-21 11-27-5-5-11-6-16-5-6 2-11 6-15 12l7-17c4-9 2-20-5-31l-10-11zm-192 0-10 11c-7 11-9 22-5 31l7 17c-4-6-9-10-15-12-4-1-11 0-16 5-7 6-10 24 11 27-2-3-2-9 3-11 3-2 7-1 8 0 2 1 4 4 5 7h-5v10h6c-2 6-6 9-15 16 8 1 17-5 19-7l2-5-1 20c1 5 2 7 6 11 4-4 5-6 6-11l-1-20 2 4c2 3 11 9 19 9-9-8-13-11-14-17h5v-10h-5c1-3 3-6 5-7 1-1 5-2 9 0s4 8 2 11c21-3 19-21 12-27-6-5-12-6-17-5-6 2-11 6-15 12l7-17c4-9 2-20-5-31l-10-11z" />
        </g>
      </svg>
    }

    <!-- Iran, Islamic Republic Of Iran-->
    @case ('ir') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#fff" d="M0 0h512v512H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
          <path fill="#6da544" d="M0 0h512v170.7H0z"/>
          <circle cx="256" cy="256" r="40" fill="#d80027"/>
        </g>
      </svg>
    }

    <!-- Libyan Arab Jamahiriya -->
    @case ('ly') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#333" d="m0 144.7 257-22.4 255 22.4v222.6l-254.9 31L0 367.3z"/>
          <path fill="#d80027" d="M0 0h512v144.7H0z"/>
          <path fill="#496e2d" d="M0 367.3h512V512H0z"/>
          <g fill="#eee">
            <path d="m315.6 209.3 21 29 34-11-21 29 21 28.8-34-11-21 29v-36l-34-11 34-11z"/>
            <path d="M258.3 328.4a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"/>
          </g>
        </g>
      </svg>
    }

    <!-- Lithuania -->
    @case ('lt') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512v170.7H0z"/>
          <path fill="#006a44" d="M0 170.7h512v170.6H0z"/>
          <path fill="#d80027" d="M0 341.3h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Micronesia, Federated States of -->
    @case ('fm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <path fill="#eee" d="m256 111.3 11 34h35.8l-29 21 11.1 34-28.9-21-29 21 11.1-34-29-21H245zM111.3 256l34-11v-35.8l21 29 34-11.1-21 28.9 21 29-34-11.1-21 29V267zM256 400.7l-11-34h-35.8l29-21-11.1-34 28.9 21 29-21-11.1 34 29 21H267zM400.7 256l-34 11v35.8l-21-29-34 11.1 21-28.9-21-29 34 11.1 21-29V245z"/>
        </g>
      </svg>
    }

    <!-- Northern Mariana Islands -->
    @case ('mp') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <path fill="#eee" d="M248 417.2a16.7 16.7 0 0 1-15-11 16.7 16.7 0 0 1-29.7-7.6 16.7 16.7 0 0 1-27.6-13.5 16.7 16.7 0 0 1-24.3-18.9 16.7 16.7 0 0 1-17.8-5 16.7 16.7 0 0 1-2.3-18.3 16.7 16.7 0 0 1-15-26.8 16.7 16.7 0 0 1-9.2-29.4 16.7 16.7 0 0 1-3.1-30.5 16.7 16.7 0 0 1 3-30.6 16.7 16.7 0 0 1 9.2-29.4 16.7 16.7 0 0 1 15-26.9 16.7 16.7 0 0 1 2.2-18.3c4.5-5.2 11.5-7 17.7-5a16.7 16.7 0 0 1 6-17.5 16.7 16.7 0 0 1 18.3-1.4 16.7 16.7 0 0 1 27.6-13.6 16.7 16.7 0 0 1 29.7-7.7 16.7 16.7 0 0 1 30.7-1.6 16.7 16.7 0 0 1 30.4 4.6 16.7 16.7 0 0 1 28.9 10.6 16.7 16.7 0 0 1 26.1 16.2c6-2.6 13.2-1.5 18.2 3.2a16.7 16.7 0 0 1 4.1 18 16.7 16.7 0 0 1 17.7 25.1 16.7 16.7 0 0 1 15.4 10.1 16.7 16.7 0 0 1-3.2 18.2 16.7 16.7 0 0 1 6.2 30c6 2.6 10.2 8.5 10.2 15.4v.4c0 6.9-4.2 12.8-10.2 15.4a16.7 16.7 0 0 1-6.1 30 16.7 16.7 0 0 1-12.2 28.3 16.7 16.7 0 0 1-.4 18.5 16.7 16.7 0 0 1-17.1 6.8 16.7 16.7 0 0 1-4.2 18c-5 4.7-12.2 5.7-18.1 3.2a16.7 16.7 0 0 1-26 16.3 16.7 16.7 0 0 1-28.8 10.7 16.7 16.7 0 0 1-30.5 4.6 16.7 16.7 0 0 1-15.9 9.4z"/>
          <circle cx="256" cy="256" r="111.3" fill="#338af3"/>
          <path fill="#acabb1" d="M280.4 218.2c5.4-4 9-10.5 9-17.9v-11c0-12.4-10-22.3-22.3-22.3H245c-12.3 0-22.3 10-22.3 22.2v11.1c0 7.4 3.6 13.9 9 18L211.5 423s11.1 11 44.5 11 44.5-11 44.5-11z"/>
          <path fill="#eee" d="m256 167 19.3 59.5H338l-50.6 36.8 19.3 59.5L256 286l-50.6 36.8 19.3-59.5-50.6-36.8h62.6z"/>
        </g>
      </svg>
    }

    <!-- Saint Kitts and Nevis -->
    @case ('kn') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M0 512 512 0v170.7L170.7 512z"/>
          <path fill="#d80027" d="M512 0v512H0z"/>
          <path fill="#000" d="M0 512 512 0v42.7L42.7 512H0z"/>
          <g fill="#fff">
            <polygon points="160,352 180,360 160,368 168,388 152,372 136,388 144,368 124,360 144,352 136,332 152,348 168,332"/>
            <polygon points="352,160 372,168 352,176 360,196 344,180 328,196 336,176 316,168 336,160 328,140 344,156 360,140"/>
          </g>
        </g>
      </svg>
    }

    <!-- South Georgia and the South Sandwich Islands -->
    @case ('gs') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
          <rect width="64" height="32" x="336" y="256" fill="#6da544" rx="16" ry="16"/>
          <circle cx="368" cy="96" r="32" fill="#ff9811"/>
          <circle cx="368" cy="144" r="48" fill="#acabb1"/>
          <path fill="#338af3" d="M320 144v77c0 36 48 48 48 48s48-12 48-48v-77z"/>
          <rect width="32" height="128" x="288" y="128" fill="#333" rx="16" ry="16"/>
          <rect width="32" height="128" x="416" y="128" fill="#333" rx="16" ry="16"/>
          <path fill="#6da544" d="m320 144 48 112 48-112z"/>
          <path fill="#ffda44" d="M288 288v32h32v8h96v-8h32v-32h-32v8h-96v-8z"/>
        </g>
      </svg>
    }

    <!-- United Arab Emirates -->
    @case ('ae') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#00732f" d="M0 0h512v170.7H0z"/>
          <path fill="#fff" d="M0 170.7h512v170.6H0z"/>
          <path fill="#000" d="M0 341.3h512V512H0z"/>
          <path fill="#d80027" d="M0 0h170.7v512H0z"/>
        </g>
      </svg>
    }

    <!-- Belize -->
    @case ('bz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="m0 44.5 257.8-23.7L512 44.5v423l-252.5 26L0 467.5z"/>
          <circle cx="256" cy="256" r="122.4" fill="#eee"/>
          <circle cx="256" cy="256" r="100.2" fill="#6da544"/>
          <circle cx="256" cy="256" r="66.8" fill="#eee"/>
          <path fill="#0052b4" d="M256 239.3 219.8 256v27.8l36.2 22.3 36.2-22.3V256z"/>
          <path fill="#ffda44" d="M219.8 222.6h72.4V256h-72.4z"/>
          <path fill="#a2001d" d="M0 0h512v44.5H0zm0 467.5h512V512H0z"/>
        </g>
      </svg>
    }

    <!-- Bermuda -->
    @case ('bm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M256 0h256v512H0V256z"/>
          <path fill="#eee" d="M0 0h33.4l31.8 16.4 35-16.4H256v133.6l-9.3 33.7 9.3 41.5V256h-47.2l-39.3-7-35.9 7.1L0 256V100.2l15.4-34.5L0 33.4z"/>
          <path fill="#496e2d" d="M445.2 256.1zm-155.8 0z"/>
          <path fill="#d80027" d="m267 235.5-102-102h-31.4L267 267z"/>
          <path fill="#d80027" d="M33.4 0v33.4H0v66.8h33.4v170.6h66.8V100.2h170.2V33.4H100.2V0z"/>
          <path fill="#0052b4" d="M180.8 133.6H256v75.2zm-47.2 47.2v75.3l75.2-.1z"/>
          <path fill="#eee" d="M289.4 133.6V256c0 59.6 155.8 59.6 155.8 0V133.6z"/>
          <path fill="#6da544" d="M289.4 256c0 59.6 77.9 78 77.9 78s78-18.4 78-78h-156z"/>
          <path fill="#a2001d" d="m367.3 207-36.2 15.6V256l36.2 22.3 36.2-22.3v-33.4z"/>
          <path fill="#338af3" d="M331.1 189.2h72.4v33.4H331z"/>
        </g>
      </svg>
    }

    <!-- Bhutan -->
    @case ('bt') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff"/></mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M0 0h512L281 293.2 0 512z"/>
          <path fill="#ff9811" d="M506.7 0 0 506.7v5.3h512V0h-5.3z"/>
          <path fill="#eee" d="M398.2 142V97.7h-85.3l-6.5 6.5c-23.2 23.2-19.3 50.2-16.5 70 2.7 18.3 3 25.3-3.8 32-6.8 7-14 6.6-32.2 4-19.7-3-46.8-6.8-70 16.4-23.2 23.2-19.3 50.3-16.4 70 2.6 18.3 3 25.4-4 32.2-6.7 6.8-13.7 6.5-32 3.8-7.2-1-14.5-2-22.4-2.2l-.5 44.6c5 0 10.6.8 16.5 1.7 7 1 15 2.2 23.5 2.2 8.7 0 18-1.3 27-5.2v35.6h66.8v-33.4H209v-22.2h22.3v-33.4h-18c.9-10.8-.6-21.2-2-30-2.5-18.4-3-25.4 4-32.2 6.8-6.8 13.8-6.5 32.2-3.8 14.3 2 32.6 4.7 50.4-3v35.6h66.8v-33.4h-33.3V231h22.3v-33.4h-17.8a130 130 0 0 0-2-30c-1.8-12.8-2.5-20-.4-25.6z"/>
        </g>
      </svg>
    }

    <!-- Cayman Islands -->
    @case ('ky') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff"/></mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
          <circle cx="367.3" cy="144.7" r="44.5" fill="#6da544"/>
          <path fill="#d80027" d="M289.4 133.5h155.8l.1 29-76.9 79.7-79.1-79.7z"/>
          <path fill="#496e2d" d="M445.2 256zm-155.8 0z"/>
          <path fill="#ffda44" d="M289.4 300.5V345h23.4a77.6 77.6 0 0 0 109 0h23.4v-44.5z"/>
          <path fill="#338af3" d="M289.3 193.7v31.2l8 16.6-7.9 14.5c.1 59.6 77.9 78 77.9 78s78-18.4 78-78l-7.7-13.2 7.7-18v-31.1l-78-10.2z"/>
          <path fill="#eee" d="M367.3 224.9c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8V256c19.7 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8zm0-62.4c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8v31.2c19.7 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8z"/>
        </g>
      </svg>
    }

    <!-- Christmas Island -->
    @case ('cx') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff"/></mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="m0 0 216.9 301.6L512 512V0z"/>
          <path fill="#0052b4" d="m0 0 512 512H0z"/>
          <circle cx="256" cy="256" r="66.8" fill="#ffda44"/>
          <path fill="#eee" d="m95.3 367.3 7 14.7 16-3.7L111 393l13 10-16 3.6.1 16.3-12.7-10.2L82.6 423v-16.3L66.9 403l12.6-10-7-14.7 15.8 3.7zM49.3 245l7.1 14.7 15.9-3.7-7.1 14.6 12.7 10.2-15.9 3.5v16.3l-12.6-10.2-12.7 10.2v-16.3l-15.9-3.5 12.8-10.2-7.1-14.6 15.8 3.7zm46-100.2 7 14.7 16-3.7-7.2 14.7 12.8 10-16 3.7.1 16.2-12.7-10.1-12.7 10.1v-16.2l-15.8-3.6 12.7-10.1-7-14.7 15.8 3.7zm57.1 78 7 14.6 15.9-3.7-7.1 14.7 12.7 10.1-15.8 3.6v16.3L152.4 268l-12.7 10.2V262l-15.8-3.6 12.7-10.1-7-14.7 15.8 3.7zm-40.8 66.7 5.5 17H135L120.5 317l5.6 17-14.5-10.5L97 333.9l5.6-17-14.5-10.5H106z"/>
          <path fill="#6da544" d="M256 300.5h22.3s9.6-17 0-33.4l22.2-22.2-11.1-22.3h-11.1s-5.6 16.7-27.9 16.7-27.8-16.7-27.8-16.7h-11.1l11.1 22.3-11.1 22.2 11.1 11.2S233.7 256 256 267c0 0 9.5 14 0 33.4z"/>
          <path fill="#ffda44" d="M422.2 140.2a44.7 44.7 0 0 0-30-50.8 83.1 83.1 0 0 1 7.5 49.9 45.6 45.6 0 0 0-10.4-11.6 45.7 45.7 0 0 0-53.7-2.4 85.3 85.3 0 0 1 35 16.7c8.3 6.6 15 15.5 20.2 24.1l-68 21.3c66.8 11.2 122.4-33.4 122.4-33.4-6.1-12.3-15.7-14.4-23-13.8z"/>
        </g>
      </svg>
    }

    <!-- Congo -->
    @case ('cg') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff"/></mask>
        <g mask="url(#a)">
          <path fill="#ffda44" d="M384 0h128v128L352 352 128 512H0V384l160-224Z"/>
          <path fill="#6da544" d="M0 384 384 0H0Z"/>
          <path fill="#d80027" d="M512 128 128 512h384z"/>
        </g>
      </svg>
    }

    <!-- Cook Islands -->
    @case ('ck') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
          <path fill="#eee" d="m345 256 4.8 14.6H365l-12.4 9 4.7 14.6-12.4-9-12.4 9 4.8-14.6-12.4-9h15.3zm-63 26 13.7 7 10.9-10.8-2.4 15.1 13.6 7-15.1 2.4-2.4 15.1-7-13.6-15.1 2.4 10.8-10.9zm-26 63 14.6-4.7V325l9 12.4 14.6-4.8-9 12.4 9 12.4-14.6-4.7-9 12.4v-15.3zm26 63 7-13.6-10.8-10.9 15.1 2.4 7-13.6 2.4 15 15.1 2.5-13.6 7 2.4 15-10.9-10.8zm63 26-4.7-14.5H325l12.4-9-4.8-14.6 12.4 9 12.4-9-4.7 14.6 12.4 9h-15.3zm63-26-13.6-7-10.9 10.9 2.4-15.2-13.6-7 15-2.3 2.5-15.1 7 13.6 15-2.4-10.8 10.9zm26-63-14.5 4.8V365l-9-12.4-14.6 4.7 9-12.4-9-12.4 14.6 4.8 9-12.4v15.3zm-26-63-7 13.7 10.9 10.9-15.2-2.4-7 13.6-2.3-15.1-15.1-2.4 13.6-7-2.4-15.1 10.9 10.8z"/>
        </g>
      </svg>
    }

    <!-- Croatia -->
    @case ('hr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"/>
          <path fill="#d80027" d="M0 0h512v167H0z"/>
          <path fill="#0052b4" d="M0 345h512v167H0z"/>
          <path fill="#338af3" d="M322.8 178h-44.5l7.4-55.7 29.7-22.2 29.6 22.2V167zm-133.6 0h44.5l-7.4-55.7-29.7-22.2-29.6 22.2V167z"/>
          <path fill="#0052b4" d="M285.7 178h-59.4v-55.7l29.7-22.2 29.7 22.2z"/>
          <path fill="#eee" d="M167 167v122.3a89 89 0 0 0 35.8 71.3l15.5-3.9 19.7 19.8a89.1 89.1 0 0 0 18 1.8 89 89 0 0 0 17.9-1.8l22.4-18.7 13 2.8a89 89 0 0 0 35.7-71.3V167z"/>
          <path fill="#d80027" d="M167 167h35.6v35.5H167zm71.2 0h35.6v35.5h-35.6zm71.2 0H345v35.5h-35.6zm-106.8 35.5h35.6v35.6h-35.6zm71.2 0h35.6v35.6h-35.6zM167 238.1h35.6v35.6H167zm35.6 35.6h35.6v35.6h-35.6zm35.6-35.6h35.6v35.6h-35.6zm71.2 0H345v35.6h-35.6zm-35.6 35.6h35.6v35.6h-35.6zm-35.6 35.6h35.6V345h-35.6zm-35.6 0h-33.3c3 13.3 9 25.4 17.3 35.6h16zM309.4 345h16a88.8 88.8 0 0 0 17.3-35.6h-33.3zm-106.8 0v15.6a88.7 88.7 0 0 0 35.6 16V345zm71.2 0v31.6a88.7 88.7 0 0 0 35.6-16V345z"/>
        </g>
      </svg>
    }

    <!-- Cyprus -->
    @case ('cy') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h512v512H0z"/>
          <path fill="#6da544" d="M400.7 222.6h-33.4a111.3 111.3 0 0 1-222.6 0h-33.4c0 66.2 44.5 122 105.2 139.2a37 37 0 0 0 3.9 40.5l36.3-29.2 36.4 29.2a37 37 0 0 0 3.7-40.8 144.8 144.8 0 0 0 103.9-138.9z"/>
          <path fill="#ffda44" d="M167 211.5s0 55.6 55.6 55.6l11.1 11.2H256s11.1-33.4 33.4-33.4c0 0 0-22.3 22.3-22.3H345s-11-44.5 44.6-77.9l-22.3-11.1s-78 55.6-133.6 44.5v22.2h-22.2l-11.2-11-33.3 22.2z"/>
        </g>
      </svg>
    }

    <!-- Dominica -->
    @case ('dm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff"/></mask>
        <g mask="url(#a)">
          <path fill="#496e2d" d="M0 0h208l48 32 48-32h208v208l-32 48 32 48v208H304l-48-32-48 32H0V304l32-48-32-48Z"/>
          <path fill="#333" d="M512 240v32l-256 32L0 272v-32l256-32z"/>
          <path fill="#ffda44" d="M512 208v32H0v-32z"/>
          <path fill="#333" d="M240 0h32l32 256-32 256h-32l-32-256Z"/>
          <path fill="#ffda44" d="M208 0h32v512h-32z"/>
          <path fill="#eee" d="M272 0h32v512h-32z"/>
          <path fill="#eee" d="M512 272v32H0v-32z"/>
          <circle cx="256" cy="256" r="122.4" fill="#d80027"/>
          <path fill="#496e2d" d="M284 270c-9-19-21-37-21-37v-13a14 14 0 0 0-27-2 11 11 0 0 0-4 21 16 16 0 0 1 9-9 14 14 0 0 0 2 2h2s-7 19-7 29c0 27 19 36 19 36l-10 9h19v-18l9 9s17-11 9-27zm-28-114 4 13h14l-11 8 4 12-11-8-11 8 4-12-11-8h14Zm-59 19 11 8 11-8-4 13 11 8h-14l-4 12-4-12h-14l11-8zm-36 50h13l4-13 4 13h14l-11 8 4 13-11-8-11 8 5-13zm0 62 11-8-5-13 11 8 11-8-4 13 11 8h-14l-4 13-4-13Zm36 50 4-13-11-8h14l4-12 4 12h13l-10 8 4 13-11-8zm59 19-4-13h-14l11-8-4-12 11 8 11-8-4 12 11 9h-14Zm59-19-11-8-11 8 4-13-10-8h13l4-12 4 12h14l-11 8zm36-50h-13l-4 13-4-13h-14l11-8-4-13 11 8 11-8-5 13zm0-62-11 8 5 13-11-8-11 8 4-13-11-8h14l4-13 4 13zm-36-50-4 13 11 8h-14l-4 12-4-12h-14l11-8-4-13 11 8z"/>
        </g>
      </svg>
    }

    <!-- Dominican Republic -->
    @case ('do') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff"/></mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M35.5 256h444l32.5-66.8V0H322.8L256 31.8v444.6L189.2 512H0V322.8z"/>
          <path fill="#0052b4" d="M479.5 256h-444L0 189.2V0h189.2L256 31.8v444.6l66.8 35.6H512V322.8z"/>
          <path fill="#eee" d="M189.2 0h133.6v189.2H512v133.6H322.8V512H189.2V322.8H0V189.2h189.2z"/>
          <path fill="#496e2d" d="M322.8 256a66.8 66.8 0 1 1-133.6 0c0-36.9 66.8-66.8 66.8-66.8s66.8 30 66.8 66.8z"/>
          <path fill="#0052b4" d="M189.2 256a66.8 66.8 0 1 1 133.6 0"/>
          <path fill="#d80027" d="M218.4 222.6v41.7a37.6 37.6 0 1 0 75.2 0v-41.7z"/>
        </g>
      </svg>
    }

    <!-- Eritrea -->
    @case ('er') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#6da544" d="M0 0h512v256H62z"/>
          <path fill="#338af3" d="M62 256h450v256H0z"/>
          <path fill="#d80027" d="M0 0v512l512-256z"/>
          <path fill="#ffda44" d="M133.6 150.3c-49.1 0-89 40-89 89v33.4a89.1 89.1 0 0 0 178 0v-33.4c0-49-40-89-89-89zm55.6 122.4c0 24.9-16.4 46-39 53v-36.3l23.7-23.6-23.6-23.6v-19.6h-33.4V256l-23.6 23.6 23.6 23.6v22.6a55.7 55.7 0 0 1-39-53.1v-33.4a55.7 55.7 0 0 1 111.3 0z"/>
        </g>
      </svg>
    }

    <!-- Falkland Islands -->
    @case ('fk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"/>
          <path fill="#ffda44" d="M411.8 300.5v11.2h-89v-11.2h-33.4V345h22.3v11.2H423V345h22.2v-44.5z"/>
          <path fill="#338af3" d="M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z"/>
          <path fill="#eee" d="M367.3 224.9c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8V256c19.6 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8zm0-62.4c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8v31.2c19.6 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8z"/>
        </g>
      </svg>
    }

    <!-- Fiji -->
    @case ('fj') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32l42-16 41 16h45l-8-16 8-15v-14l-16-42 16-41V96l-32-32 32-32V0H96L64 32 32 0Z"/>
          <path fill="#0052b4" d="M128 256v-83l83 83zm128-45-83-83h83z"/>
          <path fill="#eee" d="m367.3 144.7-78 22.3h.1v66.7l9.2 11-9.2 11.3c0 45.5 45.3 67 66.8 74.6l11.5-8.8 10.7 8.8c21.5-7.7 66.8-29.1 66.8-74.6l-8-11 8-11.3V167Z"/>
          <path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97zm317.2 39v-33.4H289.4V167h66.8v66.7h-66.8V256h66.8v74.6a111 111 0 0 0 11.1 3.4s4.4-1 11.1-3.4V256h66.8v-22.3h-66.8V167Z"/>
        </g>
      </svg>
    }

    <!-- French Southern Territories -->
    @case ('tf') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#0052b4" d="M256 0h256v512H0V256Z"/>
          <path fill="#eee" d="M0 0h256v256H0z"/>
          <path fill="#0052b4" d="M0 0h75v224H0z"/>
          <path fill="#d80027" d="M149 0h75v224h-75z"/>
          <path fill="#eee" d="m323 158 13 21h36v71l-27-43-37 59h18l19-34 39 70 39-70 19 34h18l-37-59-27 43v-39h16l12-20h-28v-12h36l13-21zm43 88h-40v14h40zm76 0h-40v14h40z"/>
          <path fill="#eee" d="m301 181 13 38-34-23h42l-34 23zm166 0 13 38-34-23h42l-34 23zM339 282l13 38-34-23h42l-34 23zm90 0 13 38-34-23h42l-34 23zm-45 34 13 38-34-23h42l-34 23z"/>
        </g>
      </svg>
    }

    <!-- Gibraltar -->
    @case ('gi') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="m0 345 256.3-31.3L512 345v167H0z"/>
          <path fill="#eee" d="M0 0h512v345H0z"/>
          <path fill="#d80027" d="M356.2 211.5V178h11.1v-22.3H345V167h-22.2v-11.2h-22.3v22.3h11.2v33.4h-22.3v-78h11.1v-22.2h-22.2v11.1H267v-11h-22v11h-11.2v-11h-22.2v22.2h11.1v77.9h-22.3V178h11.2v-22.3h-22.3V167H167v-11.2h-22.3v22.3h11.1v33.4h-22.2v89h244.8v-89z"/>
          <path fill="#ffda44" d="M256 289.4a33.4 33.4 0 0 0-11.1 64.9v46.4h-33.4v44.5H267v-91a33.4 33.4 0 0 0-11.1-64.8zm0 44.5a11.1 11.1 0 1 1 0-22.2 11.1 11.1 0 0 1 0 22.2z"/>
        </g>
      </svg>
    }

    <!-- Guam -->
    @case ('gu') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v44.6l-41.2 207.2L512 467.6V512H0v-44.4l38-219-38-204z"/>
          <path fill="#0052b4" d="M0 44.6h512v423H0z"/>
          <path fill="#d80027" d="M241.5 417.7c-3.5-3-85.7-74.5-85.7-161.6 0-87 82.2-158.6 85.7-161.6L256 82.1l14.5 12.4c3.5 3 85.7 74.4 85.7 161.6 0 87.2-82.2 158.6-85.7 161.6L256 430.1z"/>
          <path fill="#338af3" d="M334 256.1c0-78-78-144.7-78-144.7s-78 66.8-78 144.7a150 150 0 0 0 17.5 66.8h121a150 150 0 0 0 17.4-66.8z"/>
          <path fill="#0052b4" d="M334 256.1a150 150 0 0 1-17.5 66.8L256 334l-60.5-11a150 150 0 0 1-17.4-66.9h155.8z"/>
          <path fill="#ffda44" d="M256 400.8s37.5-32.2 60.5-78h-121c23 45.8 60.5 78 60.5 78z"/>
          <path fill="#6da544" d="M206 211.6h100l-50 50z"/>
          <path fill="#a2001d" d="M239.3 245h33.4v100.1h-33.4z"/>
        </g>
      </svg>
    }


    <!-- Hong Kong -->
    @case ('hk') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#eee" d="M282.4 193.7c-5.8 24.2-16.1 19.6-21.2 40.7a55.7 55.7 0 0 1 26-108.3c-10.1 42.2.4 46-4.8 67.6zM205 211.6c21.2 13 13.6 21.4 32.1 32.8a55.7 55.7 0 0 1-94.9-58.2c37 22.7 43.8 13.8 62.8 25.4zm-7 79.3c19-16.2 24.7-6.4 41.2-20.4a55.7 55.7 0 0 1-84.7 72.2c33-28.2 26.6-37.4 43.6-51.8zm73.4 31c-9.6-23 1.5-25.3-6.8-45.3a55.7 55.7 0 0 1 42.6 102.8c-16.6-40-27.3-36.9-35.8-57.4zm52.2-60c-24.9 2-23.7-9.3-45.3-7.6a55.7 55.7 0 0 1 111-8.7c-43.3 3.4-43.6 14.5-65.7 16.3z"/>
        </g>
      </svg>
    }

    <!-- Isle of Man -->
    @case ('im') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#d80027" d="M0 0h512v512H0z"/>
          <path fill="#eee" d="m350.8 171.6-18.1 64.6-54.3-10-35-72-94.4 33.4-7.4-21-24.7-3 18.6 52.5 65-16.7 18.4 52-44.9 66.3 76.3 65-14.5 17 9.7 22.9 36.1-42.3-46.8-48 35.8-42 79.8 5.8 18.2-98.6 22 4 15-19.8-54.8-10zM256 256z"/>
        </g>
      </svg>
    }

    <!-- Jamaica -->
    @case ('jm') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#333" d="M23.3 488.6 0 465V47.1l23.4-23.7 464 464 24.6-22.6V47.1l-24.5-22.7z"/>
          <path fill="#6da544" d="M23.3 23.3 47.1 0h417.7l23.8 23.4-464 464L47 512h418l22.6-24.5z"/>
          <path fill="#ffda44" d="M0 0v47.1L208.8 256 0 464.9V512h47.1L256 303.2 464.9 512H512v-47L303.1 256 512 47.2V0h-47.2L256 208.9 47 0z"/>
        </g>
      </svg>
    }

    <!-- Kazakhstan -->
    @case ('kz') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#338af3" d="M0 0h512v512H0z"/>
          <path fill="#ffda44" d="M400.7 258.8H111.3c0 20 17.4 36.2 37.4 36.2h-1.2c0 20 16.2 36.1 36.2 36.1 0 20 16.1 36.2 36.1 36.2h72.4c20 0 36.1-16.2 36.1-36.2 20 0 36.2-16.2 36.2-36.1h-1.2c20 0 37.4-16.2 37.4-36.2z"/>
          <path fill="#338af3" d="M356.2 211.5a100.2 100.2 0 0 1-200.4 0"/>
          <path fill="#ffda44" d="m332.5 211.5-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3L256 259l-23.6 25.3L228 250l-34 6.5 16.6-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.3-34.3 23.6 25.2 23.6-25.2L284 173l34-6.5-16.6 30.3z"/>
        </g>
      </svg>
    }

    <!-- South Korea -->
    @case ('kr') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h512v512H0Z"/>
          <path fill="#333" d="m350 335 24-24 16 16-24 23zm-39 39 24-24 15 16-23 24zm87 8 23-24 16 16-24 24zm-40 39 24-23 16 15-24 24Zm16-63 24-23 15 15-23 24zm-39 40 23-24 16 16-24 23zm63-221-63-63 15-15 64 63zm-63-15-24-24 16-16 23 24zm39 39-24-24 16-15 24 23zm8-87-24-23 16-16 24 24Zm39 40-23-24 15-16 24 24ZM91 358l63 63-16 16-63-63zm63 16 23 24-15 15-24-23zm-40-39 24 23-16 16-23-24zm24-24 63 63-16 16-63-63zm16-220-63 63-16-16 63-63zm23 23-63 63-15-16 63-63zm24 24-63 63-16-16 63-63z"/>
          <path fill="#d80027" d="M319 319 193 193a89 89 0 1 1 126 126z"/>
          <path fill="#0052b4" d="M319 319a89 89 0 1 1-126-126z"/>
          <circle cx="224.5" cy="224.5" r="44.5" fill="#d80027"/>
          <circle cx="287.5" cy="287.5" r="44.5" fill="#0052b4"/>
        </g>
      </svg>
    }

    <!-- Mayotte -->
    @case ('yt') {
      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
        <mask id="a">
          <circle cx="256" cy="256" r="256" fill="#fff"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#eee" d="M0 0h512v512H0z"/>
          <path fill="#acabb1" d="M113 139c-4 0-11 2-23 8a59 59 0 0 0-13 9c-28 27-20 68-11 79 3 4 16 23 32 30 22 8 36 28 37 51 0 24-15 44-34 46h-4c-19 0-36-19-37-43v2c1 29 20 52 43 52s44-12 55-32l5-8a43 43 0 0 0 4-14c4-19 6-70-47-95-40-20-45-36-40-43a4 4 0 0 1 3-1 19 19 0 0 0 18 19 15 15 0 0 0 10-4s18 18 24 11 0-7-6-14c-5-7 0-21-11-28-12-7-18-7-12-15a16 16 0 0 1 12-7s0-3-5-3zm287 0c-5 0-5 3-5 3 5 1 9 3 12 7 5 8 0 8-12 15s-6 21-12 28c-5 7-11 7-5 14 5 7 24-11 24-11a15 15 0 0 0 10 4 19 19 0 0 0 18-19 4 4 0 0 1 2 1c6 7 1 23-40 43-52 25-50 76-47 95l5 14a189 189 0 0 0 5 8c10 20 32 33 54 32 24 0 43-23 44-52v-2c-2 24-18 43-38 43h-4c-19-2-33-22-33-46 1-23 15-43 36-51 16-7 29-26 33-30 8-11 17-52-11-79a59 59 0 0 0-14-9c-12-6-18-8-22-8zM26 199c-1 0-2 1-2 3-2 16-1 52 33 64a2 2 0 0 0 3-1l6-8v-4c-5-7-22-31-22-44l-2-2a19 19 0 0 1-15-7l-1-1zm460 0-1 1a19 19 0 0 1-15 7l-2 2c0 13-17 37-21 44v4l5 8a2 2 0 0 0 3 1c34-12 35-48 34-64l-3-3z"/>
          <path fill="#0052b4" d="M211 147a22.5 22.5 0 0 0 0 45 22.5 22.5 0 0 0 0 45l45 32 45-32a22.5 22.5 0 0 0 0-45 22.5 22.5 0 1 0-22.5-22.5 22.5 22.5 0 0 0-45 0A22.5 22.5 0 0 0 211 147z"/>
          <path fill="#d80027" d="M211 327a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 211 282a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 211 237h90a22.5 22.5 0 0 1 22.5 22.5A22.5 22.5 0 0 1 301 282a22.5 22.5 0 0 1 22.5 22.5A22.5 22.5 0 0 1 301 327a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 256 327a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 211 327z"/>
          <path fill="#eee" d="M232 188a25 25 0 0 0-1 5 25 25 0 0 0 25 25 25 25 0 0 0 25-25 25 25 0 0 0-1-5 25 25 0 0 1-24 19 25 25 0 0 1-24-19z"/>
          <path fill="#ffda44" d="M283 254a4 4 0 0 0-4 4v8l-7-4a4 4 0 0 0-2-1 4 4 0 0 0-3 2 4 4 0 0 0 1 6l7 4-7 3a4 4 0 0 0-1 6 4 4 0 0 0 5 1l7-3v7a4 4 0 0 0 4 4 4 4 0 0 0 4-4v-7l7 3a4 4 0 0 0 5-1 4 4 0 0 0-1-6l-7-3 7-4a4 4 0 0 0 1-6 4 4 0 0 0-3-2 4 4 0 0 0-2 1l-7 4v-8a4 4 0 0 0-4-4zm-54 0a4 4 0 0 0-4 4v8l-7-4a4 4 0 0 0-2-1 4 4 0 0 0-3 2 4 4 0 0 0 1 6l7 4-7 3a4 4 0 0 0-1 6 4 4 0 0 0 5 1l7-3v7a4 4 0 0 0 4 4 4 4 0 0 0 4-4v-7l7 3a4 4 0 0 0 5-1 4 4 0 0 0-1-6l-7-3 7-4a4 4 0 0 0 1-6 4 4 0 0 0-3-2 4 4 0 0 0-2 1l-7 4v-8a4 4 0 0 0-4-4z"/>
        </g>
      </svg>
    }

    <!-- Serbia -->
    @case ('sp') {
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--emojione" preserveAspectRatio="xMidYMid meet" fill="#000000">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M32 2C18.9 2 7.8 10.4 3.7 22h56.6C56.2 10.4 45.1 2 32 2z" fill="#ed4c5c"/>
          <path d="M32 62c13.1 0 24.2-8.3 28.3-20H3.7C7.8 53.7 18.9 62 32 62z" fill="#f9f9f9"/>
          <path d="M3.7 22C2.6 25.1 2 28.5 2 32s.6 6.9 1.7 10h56.6c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10H3.7z" fill="#2872a0"/>
          <path d="M15.5 21.7v16.2C15.5 43.5 20.2 48 26 48s10.5-4.5 10.5-10.1V21.7h-21" fill="#ed4c5c"/>
          <path d="M29.8 46.3l-.2-.9l-.8-1.4l.3-.2l-.2-.9l-.7-1.1l.2-.1l-.2-.9l-.5-1l.8-1.5l.5 1.6l.4-.6l.6.9l.2-.6l.6.3l-.1-1.2l1.4.4l-1-1.3h.1l-.8-1.6l.2-.6l.5 1l.2-.4l.8 2.2v-.1l.4.8l.2-.4l.8 1.6l.3-.9l1.2.9s-.1-3-.1-3.9c.2-2.6 1.1-7.9.4-10.3c-.3-1.2-2.7-4.1-2.7-4.1s-.1 3.5-.7 4.6c-.2.4-2 1.5-2 1.5l-.7-.1l.3-.1l-1.3-1.3l.5-2.6l1.3-1.9l-2 .1l-1.5.4l.4.6l-.9 3.2l-.9-3.1l.4-.6l-1.5-.5l-2-.1l1.3 1.9l.5 2.6l-1.3 1.3l.3.1l-.8.2s-1.8-1.1-2-1.5c-.6-1-.7-4.6-.7-4.6s-2.4 2.9-2.7 4.1c-.7 2.5.3 7.8.4 10.3c.1 1-.1 3.9-.1 3.9l1.2-.9l.3.9l.8-1.6l.2.4l.4-.8v.1l.8-2.2l.2.4l.5-1l.2.6l-.8 1.6h.1l-1 1.3l1.4-.4V40l.6-.3l.2.6l.6-.9l.4.6l.5-1.6l.8 1.5l-.5 1l-.2.9l.2.1l-.7 1.1l-.2.9l.3.2l-.7 1.5l-.2.9l7.5-.2" fill="#ffffff"/>
          <g fill="#ffce31">
            <path d="M20 41.7l.2-.4l.9-.4l.6-.2h.4l.1-.1l-.6-.3l-.1-.1l-.5.2l-.4.3l.8-1l.7-1.6l-1.1.7l-1 1.8l-.4.2h-1l-.5-.1l-.6.3l.1.1h.4l.4.2l.9-.1l-1 .3l-.2.4v.6h.1l.1-.3h.5l.9-.8l-.7 1.1l-.1.5l.3.7l.2-.1v-.5l.4-.4z"/>
            <path d="M31.9 41.7l-.1-.4l-.9-.4l-.6-.2h-.4l-.1-.1l.6-.3l.1-.1l.5.2l.4.3l-.8-1l-.7-1.6l1.1.7l1 1.8l.4.2h1l.5-.1l.6.3l-.1.1H34l-.4.2l-.9-.1l1 .3l.2.4v.6h-.1l-.1-.3h-.5l-.9-.8l.7 1.1l.1.5l-.3.7l-.2-.1v-.5l-.4-.4z"/>
            <path d="M21.4 22.2c-1 .1-.9.8 0 1.7c.2.2.2.2.3 0c.1-.3.4-.5.6-.3c.1.2.1.3.5.2c.1.1.3.2.4.3c-.1 0-.5.1-1.1.2c-.5.1-.8-.1-1.2-.5c.1.5 1.3.8 1.2.8c.1.2.1.3.2.3c.4.1.8-.2 1.2-.1c.9.2-.6-2.3-.5-2.4c.1-.2-1.3-.6-1.6-.2"/>
            <path d="M29.6 25c.1 0 .1 0 .2-.3c-.1 0 1.1-.3 1.2-.8c-.3.4-.7.6-1.2.5c-.6-.1-1-.3-1.1-.2c.1-.1.2-.2.4-.3c.4.1.4 0 .5-.2c.2-.2.5-.1.6.3c0 .2.1.2.3 0c.9-.9 1-1.6 0-1.7c-.2-.4-1.6 0-1.5.3c0 .1-1.4 2.6-.5 2.4c.3-.2.7 0 1.1 0"/>
          </g>
          <path d="M21.6 28.6v7.3c0 2.2 2 4 4.4 4s4.4-1.8 4.4-4v-7.3h-8.8" fill="#ed4c5c"/>
          <g fill="#ffffff"> <path d="M24.8 27.3h2.5v15h-2.5z"/>
            <path d="M19.1 32.3h13.8v2.5H19.1z"/>
            <path d="M24 30.4l-1 1l.3-1l-.3-.9z"/>
            <path d="M24 36.7l-1 1l.3-1l-.3-1z"/>
            <path d="M28 30.4l1 1l-.2-1l.2-.9z"/>
            <path d="M28 36.7l1 1l-.2-1l.2-1z"/>
          </g>
          <path fill="#428bc1" d="M27 11.7h-2v2h2z"/>
          <g fill="#ffce31">
            <path d="M25.1 10.4l.2.1l.2-.1h.3v1.2H25v.4h2v-.4h-.8v-1.2h.3l.2.1l.2-.1l.2-.2l-.2-.2l-.2-.2l-.2.2h-.3v-.4l.2-.2l-.2-.2L26 9l-.2.2l-.2.2l.2.2v.4h-.3l-.2-.2l-.2.2l-.2.2z"/>
            <path d="M32.5 14.4c-1.3-.7-2.1-.9-2.4-.4c0 0 0 .1-.1.1c-1.6-.8-2.8-.9-4-.4c-1.2-.5-2.3-.4-4 .4c0-.1 0-.1-.1-.1c-.3-.5-1.1-.4-2.4.4c-1.3.7-2.5 1.7-2.2 2.1c.1.7.5 1.3 1.2 2c.8.4 2.4.5 4.1.4c2.2-.1 4.5-.1 6.7 0c1.7.1 3.3 0 4.1-.4c.7-.7 1.1-1.3 1.2-2c.4-.3-.9-1.3-2.1-2.1"/>
          </g>
          <g fill="#ed4c5c">
            <path d="M27.4 17.2c.8-.7 1.3-1.4 1.7-2.1c-.7-.2-1.4-.3-2-.2c.1.8.2 1.6.3 2.3"/>
            <path d="M24.6 17.2c.1-.8.2-1.6.4-2.4c-.6-.1-1.3 0-2 .2c.2.8.8 1.5 1.6 2.2"/>
            <path d="M32.6 15.8c-.1-.1-.3-.3-.6-.4c-.3-.1-.6-.2-.8-.2c-.1.8-.4 1.6-1.1 2.4c.3 0 .6-.1.8-.2c.8-.4 1.3-.9 1.7-1.3c.1-.1.1-.2 0-.3"/>
            <path d="M20.8 15.1c-.2 0-.5.1-.8.2c-.5.2-.8.6-.6.7c.4.4.9.8 1.7 1.3c.2.1.5.1.8.2c-.7-.8-1-1.5-1.1-2.4"/>
          </g>
          <path fill="#ffce31" d="M18.6 18.5h14.8v2H18.6z"/>
          <g fill="#428bc1">
            <path d="M18.6 18.9l-.4.7l.5.5l.7-.7z"/>
            <path d="M33.4 18.9l-.8.5l.7.7l.5-.5z"/>
            <path d="M26 18.4l-.8.7l.8.6l.8-.6z"/>
          </g>
          <g fill="#ed4c5c">
            <path d="M22.3 19.8l.7-.7l-.8-.5l-.7.6z"/>
            <path d="M29.7 19.8l.8-.6l-.7-.6l-.8.5z"/>
          </g>
        </g>
      </svg>
    }

    @default {
      <nrc-icon
        [name]="'globe'"
      />
    }
  }
</div>
